"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dictionaries = void 0;
exports.t = t;
exports.appErrorMessage = appErrorMessage;
exports.fieldErrorCodes = fieldErrorCodes;
exports.fieldErrorMessage = fieldErrorMessage;
const constants_1 = require("../constants");
const zhCN = {
    'welcome.title': '欢迎来到 Cardhub',
    'welcome.subtitle': '权威、集中的卡牌知识分享平台',
    'welcome.cta.browse': '浏览全部系列',
    'welcome.cta.search': '搜索卡牌',
    'health.ok': '后端连接正常',
    'health.fail': '后端连接失败',
    'nav.home': '首页',
    'nav.categories': '分类',
    'nav.series': '系列',
    'nav.calendar': '发售日历',
    'nav.search': '搜索',
    'nav.forum': '论坛',
    'nav.trade': '交易',
    'nav.reports': '举报队列',
    'nav.admin': '管理',
    'nav.catalog': '内容管理',
    'nav.releases': '发售条目',
    'nav.users': '用户管理',
    'nav.audit': '操作审计',
    'nav.me': '个人中心',
    'nav.meAria': '@{user} 的个人中心',
    'nav.login': '登录',
    'nav.register': '注册',
    'nav.logout': '退出登录',
    'nav.notifications': '通知',
    'notifications.bellAria': '通知',
    'notifications.bellAriaCount': '通知，{n} 条未读',
    'notifications.bellAriaCount_one': '通知，{n} 条未读',
    'notifications.bellAriaCount_other': '通知，{n} 条未读',
    'notifications.bellAriaOverflow': '通知，99 条以上未读',
    'notifications.unreadSummary': '{n} 条未读',
    'notifications.noneUnread': '没有未读通知',
    'notifications.markAll': '全部标记为已读',
    'notifications.markOne': '标为已读',
    'notifications.unreadPrefix': '未读：',
    'notifications.type.TOPIC_REPLY': '回复了你的话题',
    'notifications.type.COMMENT_REPLY': '回复了你的评论',
    'notifications.type.MENTION': '在内容中提到了你',
    'notifications.type.RESOLVED_REMOVE': '你的内容因举报已被删除',
    'notifications.type.RESOLVED_MARK': '你的内容被举报，管理员已处理',
    'notifications.actorDeleted': '已注销用户',
    'notifications.targetDeleted': '原内容已删除',
    'notifications.newAvailable': '有 {n} 条新通知',
    'notifications.empty': '还没有通知',
    'notifications.emptyHint': '有人回复你、@你，或你的内容被处理时，会在这里提醒。',
    'notifications.targetMissing': '这条回复可能已被删除或折叠。',
    'notifications.targetMissingAction': '查看全部评论',
    'notifications.targetMissingActionForum': '查看全部回帖',
    'notifications.targetInComments': '没能直接跳到这条回复，它在下面的评论里。',
    'notifications.actionFailed': '操作失败，请重试。',
    'breadcrumb.home': '首页',
    'breadcrumb.series': '系列',
    'breadcrumb.cards': '卡牌',
    'breadcrumb.aria': '面包屑导航',
    'a11y.skipToContent': '跳到主内容',
    'a11y.localeEn': 'EN',
    'a11y.localeZh': '中',
    'a11y.localeSwitchToEn': 'EN，切换到英文',
    'a11y.localeSwitchToZh': '中, Switch to Chinese',
    'a11y.openMenu': '打开导航菜单',
    'a11y.closeMenu': '关闭导航菜单',
    'a11y.commentArea': '撰写评论',
    'a11y.commentList': '评论列表',
    'a11y.loading': '加载中',
    'a11y.scrollTable': '{name}（可横向滚动）',
    'a11y.table': '表格',
    'a11y.scrollTableN': '表格 {n}（可横向滚动）',
    'a11y.scrollTableHeadingN': '{heading}：表格 {n}（可横向滚动）',
    'home.stats.series': '系列总览',
    'home.stats.cards': '已索引卡牌',
    'home.stats.source': '数据来源',
    'home.stats.sourceNote': '由 Cardhub 团队整理。',
    'home.series.loadFailed': '系列加载失败',
    'home.hero.recent': '最近发售 · {date}',
    'home.hero.latest': '最新收录',
    'home.hero.cardCount': '{count} 张卡牌',
    'home.categories.title': '分类',
    'home.categories.all': '全部分类',
    'home.latest.title': '最新收录',
    'home.latest.all': '全部系列',
    'home.upcoming.title': '即将发售',
    'home.upcoming.all': '发售日历',
    'home.hero.loadFailed': '主推系列加载失败',
    'home.categories.loadFailed': '分类加载失败',
    'home.latest.loadFailed': '最新收录加载失败',
    'home.upcoming.loadFailed': '即将发售加载失败',
    'footer.nav': '页脚',
    'footer.unofficial': 'Cardhub 是非官方资料站，与卡牌发行商无关。',
    'footer.locale': 'English',
    'region.CN': '中国大陆',
    'region.JP': '日本',
    'region.GLOBAL': '全球',
    'calendar.source': '来源',
    'calendar.newWindow': '（新窗口打开）',
    'calendar.title': '发售日历',
    'calendar.subtitle': '按发售日期列出新品',
    'calendar.prev': '上个月',
    'calendar.next': '下个月',
    'calendar.today': '本月',
    'calendar.monthNav': '月份',
    'calendar.monthStatus': '{month}，共 {count} 条',
    'calendar.todaySuffix': '今天',
    'calendar.monthOnly': '本月内，日期待定',
    'calendar.withinMonth': '{month}月内',
    'calendar.empty': '这个月没有发售条目',
    'calendar.loadError': '发售日历加载失败',
    'calendar.filter.category': '品类',
    'calendar.filter.all': '全部品类',
    'calendar.monthStatusCategory': '{month} · {category}，共 {count} 条',
    'calendar.emptyCategory': '这个月没有「{category}」的发售条目',
    'calendar.showAllCategories': '查看全部品类',
    'series.list.title': '所有系列',
    'series.list.subtitle': '探索 Cardhub 收录的全部卡牌系列',
    'series.cardCount': '收录 {count} 张卡牌',
    'meta.series': '{title} 系列，共 {count} 张卡牌。在 Cardhub 查看卡牌资料和讨论。',
    'meta.home': 'Cardhub 是卡牌百科和社区：按系列查卡牌资料、搜索卡牌，在论坛讨论，在交易板发布买卖。',
    'meta.seriesNoCount': '{title} 系列。在 Cardhub 查看卡牌资料和讨论。',
    'meta.card': '{name} · {series}{number}。在 Cardhub 查看卡牌资料、交易和讨论。',
    'meta.cardNumber': ' No.{number}',
    'series.empty': '暂无系列数据',
    'series.detail.cardsTitle': '本系列卡牌',
    'category.list.title': '分类',
    'category.list.subtitle': '按游戏或品类浏览系列',
    'category.seriesCount': '{count} 个系列',
    'category.list.empty': '还没有分类',
    'category.detail.empty': '这个分类下还没有系列',
    'series.filter.category': '品类',
    'series.filter.categoryAll': '全部品类',
    'series.filter.year': '发售年份',
    'series.filter.yearAll': '全部年份',
    'series.total_one': '共 {count} 个系列',
    'series.total_other': '共 {count} 个系列',
    'series.filterEmpty': '没有符合条件的系列',
    'series.filterClear': '清除筛选',
    'series.releaseDate': '发售于 {date}',
    'series.detail.subsetNav': '子集',
    'series.detail.subsetCount_one': '{count} 张',
    'series.detail.subsetCount_other': '{count} 张',
    'series.detail.insert': '特殊卡',
    'series.detail.ungrouped': '未分组',
    'card.detail.number': '卡号 {number}',
    'series.detail.commentsTitle': '系列评论',
    'series.detail.commentPlaceholder': '说说你对这个系列的看法…',
    'artwork.cardAlt': '{name} 的卡面',
    'artwork.seriesAlt': '{title} 系列封面',
    'card.detail.attributes': '属性',
    'card.attr.cost': '费用',
    'card.attr.attack': '攻击',
    'card.attr.health': '生命',
    'card.attr.type': '类型',
    'card.variant.parallel': '平行 · {name}',
    'card.variant.limited': '限量 /{n}',
    'card.variant.unnumbered': '不编号',
    'card.variants.title': '同组版本',
    'card.variants.base': '基础版',
    'card.variants.current': '（当前）',
    'card.variants.baseLink': '基础卡：{name}',
    'card.variants.showAll': '显示全部 {n} 个版本',
    'card.variants.loadFailed': '同组版本加载失败',
    'series.filters.parallels': '显示平行版本',
    'series.count.withParallels_one': '共 {n} 张（含平行版本）',
    'series.count.withParallels_other': '共 {n} 张（含平行版本）',
    'series.parallels.hint': '打开「显示平行版本」可查看 {n} 张平行卡',
    'admin.parallel.legend': '平行版本',
    'admin.field.parallelOf': '基础卡',
    'admin.field.parallelNone': '无（这是基础卡）',
    'admin.field.parallelName': '平行名称',
    'admin.field.parallelNameHint': '如 金箔、银折',
    'admin.field.printRun': '限量总数',
    'admin.field.printRunHint': '留空表示不编号',
    'admin.parallel.cleared': '已清空基础卡：系列已更改',
    'admin.parallel.locked_one': '这张卡已有 {n} 个平行版本，不能再挂到其他卡下',
    'admin.parallel.locked_other': '这张卡已有 {n} 个平行版本，不能再挂到其他卡下',
    'admin.parallel.printRunMin': '限量数量至少为 1，不限量请留空',
    'card.detail.rarity': '稀有度',
    'card.detail.series': '所属系列',
    'card.detail.seriesLabel': '所属系列：',
    'card.detail.loadFailed': '卡牌加载失败',
    'card.detail.bodyTitle': '介绍',
    'card.body.codeBlock': '代码块',
    'card.detail.bodyExpand': '展开全文',
    'card.detail.bodyCollapse': '收起',
    'card.lightbox.open': '查看大图：{name}',
    'card.lightbox.failed': '图片加载失败',
    'card.adjacent.aria': '上一张和下一张',
    'card.adjacent.prev': '上一张',
    'card.adjacent.next': '下一张',
    'series.releases.title': '发售信息',
    'series.releases.more': '查看发售日历 →',
    'release.source': '来源',
    'admin.card.body': '介绍（Markdown）',
    'a11y.newTab': '（新窗口打开）',
    'state.close': '关闭',
    'card.detail.commentsTitle': '评论区',
    'card.detail.loginToComment': '登录后即可发表评论',
    'card.detail.commentSubmit': '发布评论',
    'card.detail.commentEmpty': '还没有评论，来抢沙发吧',
    'card.detail.commentsLoadFailed': '评论加载失败',
    'card.detail.commentSubmitting': '正在发布…',
    'card.detail.commentPlaceholder': '说说你对这张卡的看法…',
    'card.detail.commentDelete': '删除',
    'card.detail.commentDeleteAria': '删除 @{user} 的评论',
    'card.detail.confirmDeleteComment': '删除这条评论？',
    'card.detail.commentDeleteCancel': '取消',
    'card.detail.commentDeleting': '删除中…',
    'card.detail.commentDeleted': '评论已删除',
    'card.detail.commentDeleteFailed': '删除失败，请重试',
    'card.detail.commentDeleteForbidden': '你没有权限删除这条评论',
    'card.detail.commentRateLimited': '评论太频繁，请稍后再试',
    'comments.mentionHint': '输入 @用户名 可提醒对方。',
    'comment.reply': '回复',
    'comment.replyAria': '回复 @{user}',
    'comment.repliesListAria': '对 @{user} 的回复',
    'comment.replyCount_one': '{count} 条回复',
    'comment.replyCount_other': '{count} 条回复',
    'comment.reply.submit': '回复',
    'comment.reply.submitting': '发送中…',
    'comment.reply.cancel': '取消',
    'comment.reply.posted': '回复已发布',
    'comment.reply.empty': '写点内容再回复',
    'comment.reply.parentGone': '这条评论已被删除，无法回复',
    'comment.reply.showMore_one': '展开其余 {count} 条回复',
    'comment.reply.showMore_other': '展开其余 {count} 条回复',
    'comment.reply.loaded_one': '已加载 {count} 条回复',
    'comment.reply.loaded_other': '已加载 {count} 条回复',
    'comment.reply.loadFailed': '回复加载失败',
    'comment.reply.confirmDelete': '删除这条回复？',
    'comment.reply.deleted': '回复已删除',
    'comment.confirmDeleteWithReplies_one': '删除这条评论？它的 {count} 条回复也会一起删除。',
    'comment.confirmDeleteWithReplies_other': '删除这条评论？它的 {count} 条回复也会一起删除。',
    'comment.deletedWithReplies_one': '评论和 {count} 条回复已删除',
    'comment.deletedWithReplies_other': '评论和 {count} 条回复已删除',
    'error.app.COMMENT_PARENT_GONE': '这条评论已被删除，无法回复',
    'auth.register.title': '创建账户',
    'auth.register.subtitle': '加入 Cardhub 社区，参与卡牌讨论',
    'auth.login.title': '登录',
    'auth.login.subtitle': '欢迎回来',
    'auth.login.unauthorized': '账号或密码不正确',
    'auth.register.conflict': '邮箱或用户名已被使用，请换一个',
    'auth.fields.email': '邮箱',
    'auth.fields.username': '用户名',
    'auth.fields.password': '密码',
    'auth.fields.identifier': '邮箱或用户名',
    'auth.actions.register': '注册',
    'auth.actions.login': '登录',
    'auth.actions.toLogin': '已有账户？去登录',
    'auth.actions.toRegister': '还没有账户？立即注册',
    'auth.actions.submitting': '提交中…',
    'auth.errors.password.short': '密码至少 8 位',
    'auth.errors.username.invalid': '用户名只能包含字母、数字、下划线和连字符',
    'auth.errors.email.invalid': '邮箱格式不正确',
    'auth.errors.email.tooLong': '邮箱最长 128 个字符',
    'auth.errors.identifier.tooLong': '邮箱或用户名最长 128 个字符',
    'auth.errors.required': '请填写所有必填项',
    'auth.notice.signedOutAll': '已退出所有设备，请重新登录。',
    'auth.notice.sessionExpired': '登录已失效，请重新登录。',
    'search.placeholder': '搜索卡牌或系列…',
    'search.empty': '没有找到匹配的卡牌或系列',
    'search.results': '搜索结果',
    'search.results.title': '关于 “{query}” 的搜索结果',
    'search.headerLabel': '全站搜索',
    'search.groupCards': '卡牌',
    'search.groupSeries': '系列',
    'search.viewAllFor': '查看「{query}」的全部结果',
    'search.syntaxLabel': '试试：',
    'search.trySyntax': '用「{example}」搜索',
    'search.syntaxHelp': 'r: 稀有度，s: 系列，c: 卡号，y: 发售年，OR 表示或者，- 表示排除',
    'search.unsupportedPrefix': '不支持「{token}」。可用的前缀：r:（稀有度）、s:（系列）、c:（卡号）、y:（发售年）',
    'search.ignoredYear': '已忽略「{token}」：年份要写 4 位，如 y:2024',
    'search.ignoredCardNumber': '已忽略「{token}」：卡号最多 20 个字符',
    'series.list.search': '搜索本系列',
    'series.list.searchPlaceholder': '卡名或卡号',
    'series.list.subset': '子集',
    'series.list.rarity': '稀有度',
    'series.list.sort': '排序',
    'series.list.any': '全部',
    'series.list.sort.number': '卡号',
    'series.list.sort.name': '名称',
    'series.list.sort.rarity': '稀有度',
    'series.list.sort.created': '收录时间',
    'series.list.filters': '筛选',
    'series.list.filtersCount': '筛选（{n}）',
    'series.list.total': '共 {count} 张',
    'series.list.total_one': '共 {count} 张',
    'series.list.total_other': '共 {count} 张',
    'series.list.found': '找到 {count} 张',
    'series.list.found_one': '找到 {count} 张',
    'series.list.found_other': '找到 {count} 张',
    'series.list.empty': '这个系列还没有卡牌',
    'series.list.noMatch': '没有符合条件的卡牌',
    'series.list.clear': '清除筛选',
    'series.list.searchLandmark': '筛选本系列卡牌',
    'pagination.label': '分页',
    'pagination.prev': '上一页',
    'pagination.next': '下一页',
    'pagination.page': '第 {page} 页',
    'pagination.of': '第 {page} / {count} 页',
    'search.invalidRarity': '没有「{value}」这个稀有度，可选 common、rare、epic、legendary',
    'search.filterRarity': '稀有度',
    'search.filterSeries': '系列',
    'search.filterAny': '不限',
    'search.clearFilters': '清除筛选',
    'search.prompt': '输入卡牌或系列名称开始搜索',
    'search.cardsHeading': '卡牌（{count}）',
    'search.seriesHeading': '系列（{count}）',
    'search.summary.cards': '{count} 张卡牌',
    'search.summary.series': '{count} 个系列',
    'search.resultsSummary': '找到 {cards}、{series}',
    'form.clear': '清除',
    'form.searching': '搜索中…',
    'form.searchFailed': '搜索失败',
    'form.resultsCount': '找到 {count} 条结果',
    'state.loading': '加载中…',
    'state.error': '加载失败',
    'state.notFound': '内容不存在',
    'state.retry': '重试',
    'state.retrying': '重试中…',
    'state.crashTitle': '页面出错了',
    'state.crashBody': '请重试，或返回首页。',
    'state.crashHome': '返回首页',
    // Forum (M6).
    'forum.list.title': '社区论坛',
    'forum.list.subtitle': '在这里讨论卡牌、构筑思路和新版本变化',
    'forum.list.empty': '还没有话题，第一个开聊吧',
    'forum.list.newTopic': '发布新话题',
    'forum.list.loginToPost': '登录后发布话题',
    'forum.list.loadMore': '加载更多',
    'forum.list.replyCount': '{count} 条回帖',
    'forum.badge.pinned': '置顶',
    'forum.detail.repliesTitle': '回帖（{count}）',
    'forum.detail.noReplies': '还没有回帖，来抢沙发吧',
    'forum.detail.replyLabel': '撰写回帖',
    'forum.detail.replyPlaceholder': '说点什么…',
    'forum.detail.replySubmit': '发布回帖',
    'forum.detail.replySubmitting': '正在发布…',
    'forum.detail.markdownNote': '支持 Markdown 与 GFM 表格 / 任务列表',
    'forum.detail.loginToReply': '登录后即可回帖',
    'forum.detail.delete': '删除',
    'forum.detail.deleteTopicAria': '删除这个话题',
    'forum.detail.deleteReplyAria': '删除 @{user} 的回帖',
    'forum.detail.deleteCancel': '取消',
    'forum.detail.deleting': '删除中…',
    'forum.detail.topicDeleted': '话题已删除',
    'forum.detail.replyDeleted': '回帖已删除',
    'forum.detail.deleteFailed': '删除失败，请重试',
    'forum.detail.deleteTopicForbidden': '你没有权限删除这个话题',
    'forum.detail.deleteReplyForbidden': '你没有权限删除这条回帖',
    'forum.detail.edit': '编辑',
    'forum.detail.editAria': '编辑这个话题',
    'forum.detail.editableUntil': '可在 {time} 前编辑',
    'forum.detail.edited': '已编辑',
    'forum.detail.topicEdited': '话题已更新',
    'forum.detail.pin': '置顶',
    'forum.detail.unpin': '取消置顶',
    'forum.detail.pinning': '正在置顶…',
    'forum.detail.unpinning': '正在取消置顶…',
    'forum.detail.pinned': '已置顶，话题会显示在列表最前',
    'forum.detail.unpinned': '已取消置顶',
    'forum.detail.pinFailed': '操作失败，请重试',
    'forum.detail.pinForbidden': '只有管理员可以置顶话题',
    'forum.detail.confirmDelete': '确认删除该话题？此操作不可撤销。',
    'forum.detail.confirmDeleteReply': '确认删除该回帖？此操作不可撤销。',
    'forum.detail.loadMoreReplies': '加载更多回帖',
    'forum.detail.repliesLoaded': '已加载 {count} 条回帖',
    'forum.detail.allRepliesShown': '已显示全部回帖',
    'forum.detail.loadMoreFailed': '回帖加载失败',
    'forum.new.title': '发布新话题',
    'forum.new.subtitle': '正文支持 Markdown，发布后 5 分钟内可编辑',
    'forum.new.titleLabel': '标题',
    'forum.new.titlePlaceholder': '一句话概括你想讨论的内容',
    'forum.new.bodyLabel': '正文',
    'forum.new.bodyPlaceholder': '详细描述你的话题，支持 Markdown 语法',
    'forum.new.markdownHint': '支持标题、列表、表格、代码块等常见 Markdown 语法',
    'forum.new.showPreview': '预览',
    'forum.new.hidePreview': '继续编辑',
    'forum.new.previewEmpty': '正文为空，无法预览',
    'forum.new.publish': '发布话题',
    'forum.new.publishing': '正在发布…',
    'forum.new.cancel': '取消',
    'forum.edit.title': '编辑话题',
    'forum.edit.remaining': '还可编辑 {minutes} 分钟',
    'forum.edit.remainingUnderMinute': '还可编辑不到 1 分钟',
    'forum.edit.save': '保存修改',
    'forum.edit.saving': '正在保存…',
    'forum.edit.cancel': '取消',
    'forum.edit.saveFailed': '保存失败，请重试',
    'forum.edit.expired': '已超过 5 分钟编辑时限，修改无法保存。正文还在下面，可以复制后删除话题再重新发布。',
    'forum.edit.notAllowed': '这个话题已不能编辑',
    'forum.edit.backToTopic': '返回话题',
    // Trade (M7).
    'trade.list.title': '交易意向板',
    'trade.list.subtitle': '玩家自助发布的交易意向 — Cardhub 仅做信息撮合',
    'trade.list.disclaimer': 'Cardhub 不参与交易、不担保资金安全，请通过站外联系并自行核实。',
    'trade.list.empty': '暂无交易意向',
    'trade.list.publish': '发布意向',
    'trade.list.loginToPublish': '登录后即可发布意向',
    'trade.list.filterAll': '全部',
    'trade.list.filterSell': '想出',
    'trade.list.filterBuy': '想求',
    'trade.list.cardFilter': '按卡牌筛选',
    'trade.list.loadMore': '加载更多',
    'trade.list.kindSell': '出',
    'trade.list.kindBuy': '求',
    'trade.list.statusOpen': '开放中',
    'trade.list.statusClosed': '已关闭',
    'trade.list.cardDelisted': '卡牌已下架',
    'trade.list.contact': '联系方式',
    'trade.list.note': '备注',
    'trade.list.priceFree': '面议',
    'trade.list.photos': '实物图',
    'trade.list.photoOpen': '查看实物图 {index}/{total}（新窗口打开）',
    'trade.list.photoFallback': '图片 {index}',
    'trade.list.contactSignIn': '登录后查看联系方式',
    'trade.publish.title': '发布交易意向',
    'trade.publish.kind': '意向类型',
    'trade.publish.kindSell': '想出（卖）',
    'trade.publish.kindBuy': '想求（买）',
    'trade.publish.card': '卡牌',
    'trade.publish.cardPlaceholder': '输入卡牌名称搜索…',
    'trade.publish.cardChange': '更换',
    'trade.publish.cardNotFound': '找不到这张卡牌，请重新选择',
    'trade.publish.price': '价格（可空）',
    'trade.publish.currency': '货币',
    'trade.publish.imageUrls': '实物图链接（可选）',
    'trade.publish.imageUrlsHint': '每行一个 https 链接，最多 4 张',
    'trade.publish.imagePreview': '图片预览',
    'trade.publish.contact': '联系方式（微信 / QQ / 邮箱…）',
    'trade.publish.contactHintSignedIn': '只有登录用户能看到联系方式',
    'trade.publish.note': '备注（可选，最多 500 字）',
    'trade.publish.submit': '发布意向',
    'trade.publish.submitting': '正在发布意向…',
    'trade.publish.cancel': '取消',
    'trade.publish.notSpecified': '不填写',
    'trade.publish.variantNote': '版本备注（可选）',
    'trade.publish.variantNotePlaceholder': '如：闪卡、首刷、签名',
    'trade.publish.error.cardRequired': '请选择一张卡牌',
    'trade.publish.error.price': '请输入 0 到 9,999,999,999.99 之间的价格',
    'trade.publish.error.imageUrl': '图片链接需以 https:// 开头',
    'trade.publish.error.tooManyImages': '最多 4 张图片',
    'trade.publish.error.imageTooLong': '图片链接最长 2048 个字符',
    'trade.publish.error.priceTooLong': '价格最长 64 个字符',
    'trade.publish.error.contact': '联系方式需要 2–200 个字',
    'trade.publish.rateLimited': '发布太频繁，请稍后再试',
    'trade.publish.disclaimer': 'Cardhub 不参与交易、不担保资金安全，请通过站外联系并自行核实。请勿发布违法或侵权内容。',
    'trade.condition.label': '品相',
    'trade.condition.NEAR_MINT': '近全新',
    'trade.condition.LIGHTLY_PLAYED': '轻微使用',
    'trade.condition.MODERATELY_PLAYED': '中度使用',
    'trade.condition.HEAVILY_PLAYED': '重度使用',
    'trade.condition.DAMAGED': '破损',
    'trade.language.label': '语言',
    'trade.language.ZH': '中文',
    'trade.language.EN': '英文',
    'trade.language.JA': '日文',
    'trade.language.OTHER': '其他',
    'trade.filter.any': '不限',
    'trade.filter.toggle': '筛选与排序',
    'trade.filter.toggleCount': '筛选与排序（{count}）',
    'trade.filter.priceRange': '价格区间',
    'trade.filter.minPrice': '最低价',
    'trade.filter.maxPrice': '最高价',
    'trade.filter.priceInvalid': '最低价不能高于最高价',
    'trade.filter.priceNeedsCurrency': '先选货币，再填价格区间',
    'trade.filter.clear': '清除 {label}',
    'trade.filter.clearAll': '清除全部',
    'trade.filter.invalid': '筛选条件无效',
    'trade.filter.clearInvalid': '清除筛选',
    'trade.filter.empty': '没有符合条件的意向',
    'trade.sort.label': '排序',
    'trade.sort.newest': '最新发布',
    'trade.sort.price_asc': '价格从低到高',
    'trade.sort.price_desc': '价格从高到低',
    'trade.sort.currencyHint': '只显示以 {currency} 标价的意向，面议和其他货币不显示',
    'trade.detail.byCardTitle': '该卡的交易意向',
    'trade.detail.byCardEmpty': '该卡暂无交易意向',
    'trade.detail.byCardLoadFailed': '交易意向加载失败',
    'trade.detail.byCardPublish': '发布意向',
    'trade.close': '关闭意向',
    'trade.closeAria': '关闭这条意向',
    'trade.confirmClose': '关闭这条意向？关闭后不能重新开放。',
    'trade.closeCancel': '取消',
    'trade.closing': '正在关闭…',
    'trade.closed': '意向已关闭',
    'trade.closeFailed': '关闭失败，请重试',
    'trade.closeForbidden': '只能关闭自己发布的意向',
    // Me (CH-102).
    'me.title': '个人中心',
    'me.sectionsNav': '个人中心分区',
    'me.joinedAt': '注册于 {date}',
    'me.roleAdmin': '管理员',
    'me.stats.listings': '交易意向',
    'me.stats.topics': '话题',
    'me.stats.replies': '回帖',
    'me.stats.comments': '评论',
    'me.listings.title': '我的意向',
    'me.listings.empty': '你还没有发布过交易意向',
    'me.topics.title': '我的话题',
    'me.topics.empty': '你还没有发过话题',
    'me.comments.title': '我的评论',
    'me.comments.empty': '你还没有发表过评论',
    'me.comments.onCard': '评论了 {card}',
    'me.loadMore': '加载更多',
    'collection.title': '我的收藏',
    'collection.own': '我有',
    'collection.want': '想要',
    'collection.progress': '已有 {owned} / 共 {total}',
    'collection.empty': '还没有收藏。在卡牌页点「我有」或「想要」开始记录',
    'collection.sectionList': '收藏的卡',
    'collection.sectionProgress': '系列进度',
    'collection.filter': '筛选',
    'collection.filterAll': '全部',
    'collection.filterOwned': '我有',
    'collection.filterWanted': '想要',
    'collection.badgeOwned': '我有 ×{count}',
    'collection.badgeWanted': '想要',
    'collection.retry': '重试',
    'collection.complete': '已集齐',
    'collection.none': '暂无',
    'collection.share': '分享',
    'collection.quantity': '数量',
    'collection.copied': '链接已复制',
    'collection.copyFailed': '无法复制，请手动复制地址栏中的链接',
    'collection.signInHint': '登录后可记录收藏',
    'collection.statusLoadFailed': '收藏状态加载失败',
    'me.security.title': '账号安全',
    'me.security.password': '密码',
    'me.security.passwordHint': '修改后，其他设备需要用新密码重新登录。',
    'auth.legacyPassword.notice': '你的密码是在旧版安全规则下设置的，建议修改一次密码，让账号得到完整保护。',
    'auth.legacyPassword.action': '去修改密码',
    'auth.legacyPassword.later': '稍后',
    'auth.legacyPassword.meHint': '建议修改密码：你的密码是在旧版安全规则下设置的。',
    'me.security.changePassword': '修改密码',
    'me.security.signOutAll': '退出所有设备',
    'me.security.signOutAllHint': '所有已登录的设备都会退出，包括这台设备。',
    'me.password.title': '修改密码',
    'me.password.subtitle': '修改后，这台设备保持登录，其他设备会退出。',
    'me.password.current': '当前密码',
    'me.password.new': '新密码',
    'me.password.newHint': '至少 8 位，最多 128 位',
    'me.password.confirm': '确认新密码',
    'me.password.show': '显示{field}',
    'me.password.hide': '隐藏{field}',
    'me.password.cancel': '取消',
    'me.password.submit': '修改密码',
    'me.password.submitting': '正在修改…',
    'me.password.changed': '密码已修改，其他设备已退出登录。',
    'me.password.errors.currentRequired': '请输入当前密码',
    'me.password.errors.wrong': '当前密码不正确',
    'me.password.errors.tooLong': '密码最长 128 位',
    'me.password.errors.same': '新密码不能和当前密码相同',
    'me.password.errors.confirmRequired': '请再输入一次新密码',
    'me.password.errors.mismatch': '两次输入的新密码不一致',
    'me.password.errors.rateLimited': '尝试次数过多，请稍后再试',
    'me.password.errors.failed': '修改失败，请重试',
    'me.signOutAll.title': '退出所有设备？',
    'me.signOutAll.body': '所有已登录的设备都会退出，包括这台设备。之后需要用密码重新登录。没有发出的内容不会保存。',
    'me.signOutAll.confirm': '退出所有设备',
    'me.signOutAll.pending': '正在退出…',
    'me.signOutAll.cancel': '取消',
    'me.signOutAll.failed': '操作失败，请重试',
    'report.button': '举报',
    'report.title': '举报内容',
    'report.reasonLabel': '请说明举报原因',
    'report.reasonPlaceholder': '描述违规内容、原因或证据',
    'report.submit': '提交举报',
    'report.submitting': '提交中…',
    'report.cancel': '取消',
    'report.success': '举报已提交，感谢你的协助',
    'report.loginRequired': '请先登录后再举报',
    'reports.title': '举报队列',
    'reports.subtitle': '管理员查看社区内容与交易意向的举报记录',
    'reports.loginRequired': '登录后查看举报队列',
    'reports.adminOnly': '仅管理员可查看举报队列',
    'reports.empty': '当前没有符合条件的举报记录',
    'reports.loadMore': '加载更多',
    'reports.filterAll': '全部',
    'reports.filterPending': '待处理',
    'reports.filterResolved': '已处理',
    'reports.openTarget': '打开对应内容',
    'reports.targetMissing': '对应内容已不存在，保留此举报记录供审计参考',
    'reports.target.listing': '交易意向',
    'reports.target.topic': '论坛话题',
    'reports.target.reply': '论坛回帖',
    'reports.target.comment': '卡牌 / 系列评论',
    'reports.resolve.noteLabel': '处理说明（选填）',
    'reports.resolve.notePlaceholder': '例如：已核实违规',
    'reports.resolve.markResolved': '标记已处理',
    'reports.resolve.removeTarget': '删除内容并处理',
    'reports.resolve.closeTarget': '关闭意向并处理',
    'reports.resolve.confirmRemove': '删除后无法恢复，这条内容的其他待处理举报也会一并处理。',
    'reports.resolve.confirmClose': '这条交易意向将被关闭，它的其他待处理举报也会一并处理。',
    'reports.resolve.confirmRemoveAction': '确认删除',
    'reports.resolve.confirmCloseAction': '确认关闭',
    'reports.resolve.cancel': '取消',
    'reports.resolve.submitting': '处理中…',
    'reports.resolve.successMarked': '已标记为已处理',
    'reports.resolve.successRemoved': '内容已删除，相关举报已处理',
    'reports.resolve.successClosed': '交易意向已关闭，相关举报已处理',
    'reports.resolve.failed': '处理失败，请重试',
    'reports.resolve.forbidden': '你没有权限处理这条举报',
    'reports.resolve.resolvedBy': '处理人',
    'reports.resolve.resolvedAt': '处理时间',
    'reports.resolve.resolution': '处理说明',
    'reports.resolve.deletedUser': '已注销用户',
    'admin.loginRequired': '请先登录管理员账号',
    'admin.adminOnly': '仅管理员可以管理内容',
    'admin.users.title': '用户管理',
    'admin.users.subtitle': '查找用户，封禁或解封账号',
    'admin.users.search': '按用户名或邮箱搜索',
    'admin.users.filterAll': '全部',
    'admin.users.filterActive': '正常',
    'admin.users.filterBanned': '已封禁',
    'admin.users.total_one': '共 {count} 位用户',
    'admin.users.total_other': '共 {count} 位用户',
    'admin.users.caption': '用户列表',
    'admin.users.colUser': '用户名',
    'admin.users.colEmail': '邮箱',
    'admin.users.colStatus': '状态',
    'admin.users.colJoined': '注册时间',
    'admin.users.colContent': '内容数',
    'admin.users.contentBreakdown': '话题 {topics} · 回帖 {replies} · 评论 {comments} · 交易意向 {listings}',
    'admin.users.statusActive': '正常',
    'admin.users.statusBanned': '已封禁',
    'admin.users.bannedMeta': '{time} · @{admin}',
    'admin.users.noMatch': '没有找到符合条件的用户',
    'admin.users.clearFilters': '清除筛选',
    'admin.users.gone': '这个用户已不存在，列表已刷新',
    'admin.users.ban': '封禁',
    'admin.users.unban': '解封',
    'admin.users.history': '记录',
    'admin.users.banAria': '封禁 @{user}',
    'admin.users.unbanAria': '解封 @{user}',
    'admin.users.historyAria': '查看 @{user} 的操作记录',
    'admin.ban.title': '封禁 @{user}？',
    'admin.ban.body': '封禁后，对方所有设备会立刻退出登录。重新登录后只能浏览，不能发评论、话题、回帖、交易意向，也不能举报。已经发布的内容不会删除。你可以随时解封。',
    'admin.ban.reason': '封禁原因（必填）',
    'admin.ban.reasonHint': '只有管理员能看到，会写入操作审计',
    'admin.ban.reasonRequired': '请填写原因',
    'admin.ban.confirm': '封禁',
    'admin.ban.pending': '正在封禁…',
    'admin.ban.done': '已封禁 @{user}，对方的所有设备已退出登录。',
    'admin.ban.cannotAdmin': '不能封禁管理员',
    'admin.ban.cannotSelf': '不能封禁自己',
    'admin.ban.failed': '封禁失败，请重试',
    'admin.unban.title': '解封 @{user}？',
    'admin.unban.body': '解封后，对方可以重新发评论、话题、回帖、交易意向和举报。封禁时退出的设备需要重新登录。',
    'admin.unban.reason': '解封原因（必填）',
    'admin.unban.confirm': '解封',
    'admin.unban.pending': '正在解封…',
    'admin.unban.done': '已解封 @{user}',
    'admin.unban.failed': '解封失败，请重试',
    'admin.audit.title': '操作审计',
    'admin.audit.subtitle': '记录封禁、解封、删除内容和处理举报。记录只增不改。',
    'admin.audit.caption': '操作记录',
    'admin.audit.filterLabel': '操作类型',
    'admin.audit.filterAll': '全部操作',
    'admin.audit.userFilter': '对象：@{user}',
    'admin.audit.clearUser': '清除对象筛选',
    'admin.audit.colTime': '时间',
    'admin.audit.colActor': '操作人',
    'admin.audit.colAction': '操作',
    'admin.audit.colTarget': '对象',
    'admin.audit.colReason': '原因',
    'admin.audit.action.USER_BAN': '封禁',
    'admin.audit.action.USER_UNBAN': '解封',
    'admin.audit.action.CONTENT_DELETE': '删除内容',
    'admin.audit.action.REPORT_RESOLVE': '处理举报',
    'admin.audit.target.TOPIC': '话题',
    'admin.audit.target.REPLY': '回帖',
    'admin.audit.target.COMMENT': '评论',
    'admin.audit.target.LISTING': '交易意向',
    'admin.audit.target.CARD': '卡牌',
    'admin.audit.target.SERIES': '系列',
    'admin.audit.target.REPORT': '举报',
    'admin.audit.owner': '作者 @{user}',
    'admin.audit.noReason': '未填写',
    'admin.audit.empty': '还没有操作记录',
    'admin.audit.noMatch': '没有符合条件的记录',
    'ban.banner.title': '你的账号已被封禁',
    'ban.banner.body': '你仍然可以浏览内容、管理自己的交易意向和账号设置，但不能发表评论、话题、回帖、交易意向，也不能举报。',
    'ban.cannotComment': '你的账号已被封禁，不能发表评论。',
    'ban.cannotReply': '你的账号已被封禁，不能回帖。',
    'ban.cannotPost': '你的账号已被封禁，不能发布话题。',
    'ban.cannotEdit': '你的账号已被封禁，不能编辑话题。',
    'ban.cannotTrade': '你的账号已被封禁，不能发布交易意向。',
    'ban.actionBlocked': '你的账号已被封禁，这次操作没有完成。',
    'ban.backToForum': '返回论坛',
    'ban.backToTrade': '返回交易板',
    'admin.catalog.title': '内容管理',
    'admin.catalog.subtitle': '管理系列和卡牌，保存后前台立即可见',
    'admin.series.new': '新建系列',
    'admin.series.edit': '编辑系列',
    'admin.series.import': '导入 JSON',
    'admin.series.caption': '全部系列',
    'admin.series.empty': '还没有系列。新建一个，或者用 JSON 批量导入。',
    'admin.releases.title': '发售条目',
    'admin.releases.new': '新建条目',
    'admin.releases.edit': '编辑条目',
    'admin.releases.empty': '还没有发售条目',
    'admin.releases.deleteTitle': '删除这个发售条目？',
    'admin.releases.deleteBody': '「{title}」会从日历上消失，系列不受影响。',
    'admin.releases.saved': '已保存',
    'admin.releases.loadError': '发售条目加载失败',
    'admin.releases.missing': '发售条目不存在',
    'admin.releases.seriesMissing': '系列不存在',
    'admin.releases.categoryMissing': '品类不存在',
    'admin.releases.monthOnly': '只知道月份',
    'admin.releases.dateHint': '格式 2026-11-06',
    'admin.releases.dateHintMonth': '格式 2026-11',
    'admin.releases.region': '地区',
    'admin.releases.regionAny': '不限',
    'admin.releases.series': '关联系列',
    'admin.releases.seriesPlaceholder': '按系列名搜索',
    'admin.releases.seriesEmpty': '没有匹配的系列',
    'admin.releases.categoryNone': '不限',
    'admin.releases.note': '备注',
    'admin.releases.sourceUrl': '来源链接',
    'admin.releases.sourceHint': '必须以 https:// 开头；服务器不会访问这个地址',
    'admin.releases.col.date': '日期',
    'admin.releases.col.region': '地区',
    'admin.releases.col.series': '关联系列',
    'admin.col.cover': '封面',
    'admin.col.image': '卡图',
    'admin.col.title': '标题',
    'admin.col.name': '名称',
    'admin.col.slug': 'slug',
    'admin.col.cards': '卡牌数',
    'admin.col.rarity': '稀有度',
    'admin.col.updated': '更新时间',
    'admin.col.actions': '操作',
    'admin.action.edit': '编辑',
    'admin.action.view': '前台查看',
    'admin.action.delete': '删除',
    'admin.action.editAria': '编辑「{name}」',
    'admin.action.viewAria': '在前台查看「{name}」（新窗口打开）',
    'admin.action.deleteAria': '删除「{name}」',
    'admin.cancel': '取消',
    'admin.deleting': '正在删除…',
    'admin.deleteFailed': '删除失败，请重试',
    'admin.deleteReason.label': '删除原因（选填，只有管理员能看到）',
    'admin.deleteReason.count': '{n}/500',
    'admin.category.deleteBody': '该品类下的系列不会删除，只是不再属于任何品类。',
    'admin.subset.deleteBody_one': '子集里的 {count} 张卡不会删除，会移到「未分组」。',
    'admin.subset.deleteBody_other': '子集里的 {count} 张卡不会删除，会移到「未分组」。',
    'admin.catalog.seriesTab': '系列',
    'admin.catalog.categoriesTab': '品类',
    'admin.category.new': '新建品类',
    'admin.category.edit': '编辑品类',
    'admin.category.empty': '还没有品类',
    'admin.category.created': '已创建品类 {name}',
    'admin.category.deleted': '已删除品类 {name}',
    'admin.category.deleteTitle': '删除品类 {name}？',
    'admin.field.category': '品类',
    'admin.field.categoryNone': '不属于任何品类',
    'admin.field.releaseDate': '发售日期',
    'admin.field.cardNumber': '卡号',
    'admin.field.cardNumberHint': '最多 20 个字符，留空表示没有卡号。前台会显示成 #001 这样。',
    'admin.field.subset': '子集',
    'admin.field.subsetNone': '未分组',
    'admin.field.sortOrder': '排序',
    'admin.subset.title': '子集',
    'admin.subset.new': '新建子集',
    'admin.subset.edit': '编辑子集',
    'admin.subset.empty': '这个系列还没有子集',
    'admin.subset.saved': '子集已保存',
    'admin.subset.deleted': '已删除子集 {name}',
    'admin.subset.kindBase': '基础',
    'admin.subset.kindInsert': '特殊',
    'admin.subset.deleteTitle': '删除子集 {name}？',
    'admin.series.forceSubsets_one': '以及 {count} 个子集。',
    'admin.series.forceSubsets_other': '以及 {count} 个子集。',
    'admin.series.confirmDelete': '删除系列「{title}」？此操作不可撤销。',
    'admin.series.forceTitle': '删除系列「{title}」及其全部卡牌',
    'admin.series.forceTitleSeriesComments': '删除系列「{title}」及其系列评论',
    'admin.series.forceBody': '这会同时永久删除这个系列下的 {cards}，以及这些卡牌下的 {comments}。引用这些卡牌的交易意向不会删除，但会显示为「卡牌已下架」。此操作不可撤销。',
    'admin.series.forceBodySeriesComments': '这会永久删除这个系列上的 {comments}。此操作不可撤销。',
    'admin.count.cards_one': '{count} 张卡牌',
    'admin.count.cards_other': '{count} 张卡牌',
    'admin.count.comments_one': '{count} 条评论',
    'admin.count.comments_other': '{count} 条评论',
    'admin.count.seriesComments_one': '{count} 条系列评论',
    'admin.count.seriesComments_other': '{count} 条系列评论',
    'admin.series.forceConfirmLabel': '输入系列 slug「{slug}」以确认',
    'admin.series.forceConfirm': '永久删除',
    'admin.series.created': '已创建系列「{title}」',
    'admin.series.deleted': '已删除系列「{title}」',
    'admin.series.deletedWithCards': '已删除系列「{title}」和 {cards}',
    'admin.cards.new': '新建卡牌',
    'admin.cards.edit': '编辑卡牌',
    'admin.cards.caption': '{series} 的卡牌',
    'admin.cards.filter': '按名称或 slug 筛选',
    'admin.cards.empty': '这个系列还没有卡牌',
    'admin.cards.confirmDelete': '删除「{name}」？这张卡的评论会一起删除，引用它的交易意向会显示为「卡牌已下架」。此操作不可撤销。',
    'admin.cards.created': '已创建卡牌「{name}」',
    'admin.cards.deleted': '已删除卡牌「{name}」',
    'admin.cards.saveAndNext': '保存并新建下一张',
    'admin.form.create': '创建',
    'admin.form.save': '保存修改',
    'admin.form.saving': '正在保存…',
    'admin.saved': '修改已保存',
    'admin.saveFailed': '保存失败，请重试',
    'admin.field.slug': 'slug',
    'admin.field.slugHint': '小写字母、数字和连字符，例如 celestial-dawn。创建后不能修改。',
    'admin.field.slugLocked': '创建后不能修改（网址和交易意向都依赖它）',
    'admin.field.title': '标题',
    'admin.field.name': '名称',
    'admin.field.description': '简介',
    'admin.field.series': '所属系列',
    'admin.field.rarity': '稀有度',
    'admin.field.coverUrl': '封面图片链接',
    'admin.field.imageUrl': '卡图链接',
    'admin.field.imageHint': '填 https:// 开头的图片链接，留空则显示默认渐变。建议比例 {ratio}',
    'admin.field.preview': '预览',
    'admin.field.previewFailed': '这张图片加载不出来，前台会显示默认渐变。请检查链接，或者确认图床允许外链。',
    'admin.error.required': '必填',
    'admin.error.slugFormat': 'slug 只能包含小写字母、数字和连字符',
    'admin.error.slugTaken': '这个 slug 已被占用',
    'admin.error.imageUrl': '请填写 https:// 开头的图片链接，或者留空',
    'admin.error.imageTooLong': '图片链接最长 {max} 个字符',
    'admin.error.rarity': '必须是 common、rare、epic、legendary 之一',
    'admin.error.invalidType': '格式不对',
    'admin.error.slugDuplicateInFile': '文件里有重复的 slug',
    'admin.error.seriesNotFound': '找不到这个系列',
    'admin.error.unknown': '出错了：{message}',
    'admin.attrs.label': '属性',
    'admin.attrs.empty': '还没有属性',
    'admin.attrs.add': '添加属性',
    'admin.attrs.keyAria': '第 {n} 行属性名',
    'admin.attrs.typeAria': '第 {n} 行类型',
    'admin.attrs.valueAria': '第 {n} 行的值',
    'admin.attrs.typeText': '文本',
    'admin.attrs.typeNumber': '数字',
    'admin.attrs.typeBool': '是 / 否',
    'admin.attrs.true': '是',
    'admin.attrs.false': '否',
    'admin.attrs.remove': '删除属性「{key}」',
    'admin.attrs.removeRow': '删除第 {n} 行',
    'admin.attrs.errorKey': '请填写属性名',
    'admin.attrs.errorDuplicate': '属性名重复',
    'admin.attrs.errorNumber': '请输入数字',
    'admin.attrs.errorTooMany': '最多 {max} 个属性',
    'admin.attrs.errorKeyLength': '属性名最长 {max} 个字符',
    'admin.attrs.errorValueLength': '属性值最长 {max} 个字符',
    'admin.attrs.atLimit': '已有 {count} 个属性，最多 {max} 个',
    'admin.attrs.colKey': '属性名',
    'admin.attrs.colType': '类型',
    'admin.attrs.colValue': '值',
    'admin.unsaved.title': '放弃未保存的修改？',
    'admin.unsaved.body': '离开这个页面后，刚才的修改不会保存。',
    'admin.unsaved.stay': '继续编辑',
    'admin.unsaved.discard': '放弃修改',
    'admin.import.title': '导入 JSON',
    'admin.import.subtitle': '格式和 seed-data 的 SeedSeries[] 相同，按 slug 新增或更新',
    'admin.import.example': '查看格式示例',
    'admin.import.paste': 'JSON 内容',
    'admin.import.file': '选择文件',
    'admin.import.preview': '预览',
    'admin.import.previewing': '正在预览…',
    'admin.import.parseError': '第 {line} 行附近的 JSON 格式有误',
    'admin.import.summary': '新增 {newSeries}、{newCards}；更新 {updSeries}、{updCards}；{errors}',
    'admin.import.summary.series': '{count} 个系列',
    'admin.import.summary.cards': '{count} 张卡牌',
    'admin.import.summary.updatedSeries': '{count} 个系列',
    'admin.import.summary.updatedCards': '{count} 张卡牌',
    'admin.import.summary.errors': '{count} 处错误',
    'admin.import.caption': '导入预览',
    'admin.import.colKind': '类型',
    'admin.import.colResult': '结果',
    'admin.import.colProblem': '问题',
    'admin.import.kindSeries': '系列',
    'admin.import.kindCard': '卡牌',
    'admin.import.create': '新增',
    'admin.import.update': '更新',
    'admin.import.unchanged': '无变化',
    'admin.import.error': '错误',
    'admin.import.all': '全部',
    'admin.import.errorsOnly': '只看错误',
    'admin.import.blocked': '有 {count} 处错误，修正后才能导入',
    'admin.import.previewStale': '内容已修改，请重新预览',
    'admin.import.previewTitle': '预览结果',
    'admin.import.nothing': '没有需要导入的变化',
    'admin.import.execute': '导入',
    'admin.import.confirm': '将新增 {create} 条、更新 {update} 条记录。更新会覆盖后台已有的修改。',
    'admin.import.confirmAction': '确认导入',
    'admin.import.executing': '正在导入…',
    'admin.import.done': '导入完成：新增 {create} 条，更新 {update} 条',
    'admin.import.failed': '导入失败，没有任何记录被修改',
    'admin.import.tooManyRows': '一次最多导入 {max} 行，当前 {count} 行',
    'admin.import.tooLarge': '一次最多导入 1MB',
    'error.payloadTooLarge': '内容太大，请精简后重试',
    'error.internal': '出了点问题，请稍后再试',
    'error.actionFailed': '操作没有完成，请稍后再试',
    'error.notFound': '内容不存在或已被删除',
    'error.forbidden': '你没有权限这样做',
    'error.app.PARSE_ERROR': '请求无法解析，请重试',
    'error.app.BAD_REQUEST': '请求无效，请检查后再试',
    'error.app.VALIDATION': '填写的内容不符合要求，请修改后再试',
    'error.app.INTERNAL_SERVER_ERROR': '出了点问题，请稍后再试',
    'error.app.NOT_IMPLEMENTED': '这个功能还不可用',
    'error.app.BAD_GATEWAY': '服务暂时不可用，请稍后再试',
    'error.app.SERVICE_UNAVAILABLE': '服务暂时不可用，请稍后再试',
    'error.app.GATEWAY_TIMEOUT': '服务响应超时，请稍后再试',
    'error.app.UNAUTHORIZED': '登录已失效，请重新登录',
    'error.app.FORBIDDEN': '你没有权限这样做',
    'error.app.NOT_FOUND': '内容不存在或已被删除',
    'error.app.METHOD_NOT_SUPPORTED': '请求方式不正确',
    'error.app.TIMEOUT': '请求超时，请稍后再试',
    'error.app.CONFLICT': '已经有相同的内容，请修改后再试',
    'error.app.PRECONDITION_FAILED': '当前状态不允许这个操作',
    'error.app.PAYLOAD_TOO_LARGE': '内容太大，请精简后重试',
    'error.app.UNSUPPORTED_MEDIA_TYPE': '不支持这种内容格式',
    'error.app.UNPROCESSABLE_CONTENT': '无法处理提交的内容',
    'error.app.TOO_MANY_REQUESTS': '操作太频繁，请稍后再试',
    'error.app.CLIENT_CLOSED_REQUEST': '请求已取消',
    'error.app.WRONG_PASSWORD': '当前密码不正确',
    'error.app.SAME_PASSWORD': '新密码不能和当前密码相同',
    'error.app.USER_BANNED': '你的账号已被封禁，这次操作没有完成。',
    'error.app.CANNOT_BAN_ADMIN': '不能封禁管理员',
    'error.app.CANNOT_BAN_SELF': '不能封禁自己',
    'error.app.ALREADY_BANNED': '这个用户已经被封禁',
    'error.app.NOT_BANNED': '这个用户没有被封禁',
    'error.app.UNKNOWN': '出了点问题，请稍后再试',
    'error.app.unknown': '出了点问题，请稍后再试',
    'error.unsupportedMedia': '不支持这种内容格式',
    'error.requestRejected': '请求未能通过校验',
    'error.field.slug_format': '只能用小写字母、数字和短横线',
    'error.field.username_too_short': '用户名至少 3 个字符',
    'error.field.username_too_long': '用户名最多 24 个字符',
    'error.field.username_format': '只能用字母、数字、下划线和连字符',
    'error.field.email_format': '邮箱格式不正确',
    'error.field.email_too_long': '邮箱最多 128 个字符',
    'error.field.password_too_short': '密码至少 8 个字符',
    'error.field.password_too_long': '密码最多 128 个字符',
    'error.field.identifier_too_short': '邮箱或用户名不能为空',
    'error.field.identifier_too_long': '邮箱或用户名最多 128 个字符',
    'error.field.comment_required': '评论不能为空',
    'error.field.comment_too_long': '评论最多 500 个字符',
    'error.field.title_required': '标题不能为空',
    'error.field.title_too_long': '标题最多 120 个字符',
    'error.field.description_too_long': '简介最多 5000 个字符',
    'error.field.body_required': '正文不能为空',
    'error.field.body_too_long': '正文最多 10000 个字符',
    'error.field.reply_required': '回帖不能为空',
    'error.field.reply_too_long': '回帖最多 5000 个字符',
    'error.field.currency_format': '货币代码必须是 3 个大写字母',
    'error.field.price_range': '价格必须是 0 到 9,999,999,999.99 之间的数字',
    'error.field.price_needs_currency': '先选货币，再填价格区间',
    'error.field.image_https': '图片链接必须以 https:// 开头',
    'error.field.image_too_many': '最多 4 张图片',
    'error.field.contact_too_short': '联系方式至少 2 个字符',
    'error.field.contact_too_long': '联系方式最多 200 个字符',
    'error.field.note_too_long': '说明最多 500 个字符',
    'error.field.variant_note_too_long': '版本备注最多 40 个字符',
    'error.field.reason_too_short': '原因至少 4 个字符',
    'error.field.reason_too_long': '原因最多 500 个字符',
    'error.field.resolution_too_long': '处理说明最多 500 个字符',
    'error.field.image_url': '图片链接必须留空，或以 https://、gradient: 开头',
    'error.field.attributes_too_many': '最多 40 个属性',
    'error.field.invalid_date': '日期必须是有效的 YYYY-MM-DD',
    'error.field.release_region': '地区只能选中国大陆、日本或全球',
    'error.field.release_note_too_long': '备注最多 500 个字符',
    'error.field.source_url': '来源链接必须以 https:// 开头',
    'error.field.release_range_order': '开始日期不能晚于结束日期',
    'error.field.release_range_too_long': '日期区间最多 366 天',
    'error.field.delete_reason_too_long': '删除原因最多 500 个字符',
    'error.field.invalid': '填写的内容不符合要求',
    'error.field.invalid_type': '填写的类型不正确',
    'error.field.too_big': '内容超出长度限制',
    'error.field.card_body_too_long': '长描述最多 20000 个字符',
    'error.field.too_small': '内容长度不够',
    'error.field.invalid_format': '格式不正确',
    'error.field.not_multiple_of': '数值必须是规定的倍数',
    'error.field.unrecognized_keys': '包含无法识别的字段',
    'error.field.invalid_union': '填写的内容不符合要求',
    'error.field.invalid_key': '字段名不符合要求',
    'error.field.invalid_element': '列表里有不符合要求的值',
    'error.field.invalid_value': '这个选项不可用',
    'error.field.collection_quantity': '数量只能是 0 到 99 的整数',
    'error.field.parallel_cross_series': '基础卡必须属于同一系列',
    'error.field.parallel_chain': '只能挂到基础卡，不能挂到平行版本',
    'error.field.parallel_self': '不能把卡设为自己的平行版本',
    'error.field.parallel_has_children': '这张卡已有平行版本，不能再挂到其他卡下',
    'error.field.parallel_base_missing': '找不到这张基础卡',
    'error.field.parallel_name_required': '请填写平行名称',
    'admin.import.back': '返回内容管理',
    'admin.import.already': '这份内容已经导入过，请修改后再导入',
    // Miniapp-specific copy (reused across weapp/alipay/h5).
    'miniapp.home.browse': '浏览系列',
    'miniapp.home.search': '搜索卡牌',
    'miniapp.home.login': '登录',
    'miniapp.home.profile': '你已登录为 @{username}',
    'miniapp.home.logout': '退出登录',
    'miniapp.home.featured': '热门系列',
    'miniapp.home.viewAll': '查看全部 →',
    'miniapp.toast.loginOk': '登录成功',
    'miniapp.toast.registerOk': '注册成功',
    'miniapp.toast.commentOk': '评论成功',
    'miniapp.toast.logoutOk': '已退出登录',
};
const enUS = {
    'welcome.title': 'Welcome to Cardhub',
    'welcome.subtitle': 'A central, authoritative card knowledge platform',
    'welcome.cta.browse': 'Browse all series',
    'welcome.cta.search': 'Search cards',
    'health.ok': 'Backend reachable',
    'health.fail': 'Backend unreachable',
    'nav.home': 'Home',
    'nav.categories': 'Categories',
    'nav.series': 'Series',
    'nav.calendar': 'Release calendar',
    'nav.search': 'Search',
    'nav.forum': 'Forum',
    'nav.trade': 'Trade',
    'nav.reports': 'Reports',
    'nav.admin': 'Admin',
    'nav.catalog': 'Catalog',
    'nav.releases': 'Releases',
    'nav.users': 'Users',
    'nav.audit': 'Audit log',
    'nav.me': 'My account',
    'nav.meAria': '@{user}, my account',
    'nav.login': 'Sign in',
    'nav.register': 'Sign up',
    'nav.logout': 'Sign out',
    'nav.notifications': 'Notifications',
    'notifications.bellAria': 'Notifications',
    'notifications.bellAriaCount': 'Notifications, {n} unread',
    'notifications.bellAriaCount_one': 'Notifications, {n} unread',
    'notifications.bellAriaCount_other': 'Notifications, {n} unread',
    'notifications.bellAriaOverflow': 'Notifications, more than 99 unread',
    'notifications.unreadSummary': '{n} unread',
    'notifications.unreadSummary_one': '1 unread',
    'notifications.unreadSummary_other': '{n} unread',
    'notifications.noneUnread': 'No unread notifications',
    'notifications.markAll': 'Mark all as read',
    'notifications.markOne': 'Mark as read',
    'notifications.unreadPrefix': 'Unread:',
    'notifications.type.TOPIC_REPLY': 'replied to your topic',
    'notifications.type.COMMENT_REPLY': 'replied to your comment',
    'notifications.type.MENTION': 'mentioned you',
    'notifications.type.RESOLVED_REMOVE': 'Your post was removed after a report',
    'notifications.type.RESOLVED_MARK': 'A report on your post was reviewed',
    'notifications.actorDeleted': 'Deleted user',
    'notifications.targetDeleted': 'The original post was deleted',
    'notifications.newAvailable': '{n} new notifications',
    'notifications.newAvailable_one': '1 new notification',
    'notifications.newAvailable_other': '{n} new notifications',
    'notifications.empty': 'No notifications yet',
    'notifications.emptyHint': "You'll see replies, mentions, and moderation updates here.",
    'notifications.targetMissing': 'This reply may have been deleted or collapsed.',
    'notifications.targetMissingAction': 'See all comments',
    'notifications.targetMissingActionForum': 'See all replies',
    'notifications.targetInComments': "Couldn't jump straight to this reply. It's in the comments below.",
    'notifications.actionFailed': "That didn't work. Try again.",
    'breadcrumb.home': 'Home',
    'breadcrumb.series': 'Series',
    'breadcrumb.cards': 'Cards',
    'breadcrumb.aria': 'Breadcrumb',
    'a11y.skipToContent': 'Skip to main content',
    'a11y.localeEn': 'EN',
    'a11y.localeZh': '中',
    'a11y.localeSwitchToEn': 'EN，切换到英文',
    'a11y.localeSwitchToZh': '中, Switch to Chinese',
    'a11y.openMenu': 'Open navigation menu',
    'a11y.closeMenu': 'Close navigation menu',
    'a11y.commentArea': 'Write a comment',
    'a11y.commentList': 'Comments',
    'a11y.loading': 'Loading',
    'a11y.scrollTable': '{name} (scrollable)',
    'a11y.table': 'Table',
    'a11y.scrollTableN': 'Table {n} (scrollable)',
    'a11y.scrollTableHeadingN': '{heading}: Table {n} (scrollable)',
    'home.stats.series': 'Series indexed',
    'home.stats.cards': 'Cards indexed',
    'home.stats.source': 'Data source',
    'home.stats.sourceNote': 'Curated by the Cardhub team.',
    'home.series.loadFailed': "Couldn't load series",
    'home.hero.recent': 'Released {date}',
    'home.hero.latest': 'Newly added',
    'home.hero.cardCount': '{count} cards',
    'home.hero.cardCount_one': '{count} card',
    'home.hero.cardCount_other': '{count} cards',
    'home.categories.title': 'Categories',
    'home.categories.all': 'All categories',
    'home.latest.title': 'Newly added',
    'home.latest.all': 'All series',
    'home.upcoming.title': 'Coming soon',
    'home.upcoming.all': 'Release calendar',
    'home.hero.loadFailed': "Couldn't load the featured series.",
    'home.categories.loadFailed': "Couldn't load categories.",
    'home.latest.loadFailed': "Couldn't load new series.",
    'home.upcoming.loadFailed': "Couldn't load upcoming releases.",
    'footer.nav': 'Footer',
    'footer.unofficial': 'Cardhub is an unofficial fan site, not affiliated with any card publisher.',
    'footer.locale': '中文',
    'region.CN': 'China mainland',
    'region.JP': 'Japan',
    'region.GLOBAL': 'Global',
    'calendar.source': 'Source',
    'calendar.newWindow': '(opens in a new window)',
    'calendar.title': 'Release calendar',
    'calendar.subtitle': 'Upcoming and recent releases by date',
    'calendar.prev': 'Previous month',
    'calendar.next': 'Next month',
    'calendar.today': 'This month',
    'calendar.monthNav': 'Month',
    'calendar.monthStatus_one': '{month}, {count} release',
    'calendar.monthStatus_other': '{month}, {count} releases',
    'calendar.todaySuffix': 'Today',
    'calendar.monthOnly': 'Later this month, date TBA',
    'calendar.withinMonth': 'In {month}',
    'calendar.empty': 'No releases this month.',
    'calendar.loadError': "Couldn't load the release calendar.",
    'calendar.filter.category': 'Category',
    'calendar.filter.all': 'All categories',
    'calendar.monthStatusCategory_one': '{month} · {category}, {count} release',
    'calendar.monthStatusCategory_other': '{month} · {category}, {count} releases',
    'calendar.emptyCategory': 'No {category} releases this month.',
    'calendar.showAllCategories': 'Show all categories',
    'series.list.title': 'All series',
    'series.list.subtitle': 'Explore every card series indexed in Cardhub',
    'series.cardCount': '{count} cards inside',
    'series.cardCount_one': '{count} card inside',
    'series.cardCount_other': '{count} cards inside',
    'meta.series': '{title}: {count} cards. See card details and discussion on Cardhub.',
    'meta.home': 'Cardhub is a trading card encyclopedia and community: browse series and card pages, search cards, talk in the forum, and post on the trading board.',
    'meta.series_one': '{title}: {count} card. See card details and discussion on Cardhub.',
    'meta.series_other': '{title}: {count} cards. See card details and discussion on Cardhub.',
    'meta.seriesNoCount': '{title}. See card details and discussion on Cardhub.',
    'meta.card': '{name} from {series}{number}. See details, trades, and discussion on Cardhub.',
    'meta.cardNumber': ', No. {number}',
    'series.empty': 'No series yet',
    'series.detail.cardsTitle': 'Cards in this series',
    'category.list.title': 'Categories',
    'category.list.subtitle': 'Browse series by game or category',
    'category.seriesCount': '{count} series',
    'category.list.empty': 'No categories yet',
    'category.detail.empty': 'No series in this category yet',
    'series.filter.category': 'Category',
    'series.filter.categoryAll': 'All categories',
    'series.filter.year': 'Release year',
    'series.filter.yearAll': 'All years',
    'series.total_one': '{count} series',
    'series.total_other': '{count} series',
    'series.filterEmpty': 'No series match these filters.',
    'series.filterClear': 'Clear filters',
    'series.releaseDate': 'Released {date}',
    'series.detail.subsetNav': 'Subsets',
    'series.detail.subsetCount_one': '{count} card',
    'series.detail.subsetCount_other': '{count} cards',
    'series.detail.insert': 'Insert',
    'series.detail.ungrouped': 'Other cards',
    'card.detail.number': 'No. {number}',
    'series.detail.commentsTitle': 'Series comments',
    'series.detail.commentPlaceholder': 'Share your thoughts about this series…',
    'artwork.cardAlt': 'Card art for {name}',
    'artwork.seriesAlt': '{title} series cover',
    'card.detail.attributes': 'Attributes',
    'card.attr.cost': 'Cost',
    'card.attr.attack': 'Attack',
    'card.attr.health': 'Health',
    'card.attr.type': 'Type',
    'card.variant.parallel': 'Parallel · {name}',
    'card.variant.limited': 'Limited /{n}',
    'card.variant.unnumbered': 'Unnumbered',
    'card.variants.title': 'Versions',
    'card.variants.base': 'Base',
    'card.variants.current': '(current)',
    'card.variants.baseLink': 'Base card: {name}',
    'card.variants.showAll': 'Show all {n} versions',
    'card.variants.loadFailed': "Couldn't load versions.",
    'series.filters.parallels': 'Show parallels',
    'series.count.withParallels_one': '1 card (incl. parallels)',
    'series.count.withParallels_other': '{n} cards (incl. parallels)',
    'series.parallels.hint': 'Turn on Show parallels to see {n} parallel cards.',
    'admin.parallel.legend': 'Parallels',
    'admin.field.parallelOf': 'Base card',
    'admin.field.parallelNone': 'None (this is a base card)',
    'admin.field.parallelName': 'Parallel name',
    'admin.field.parallelNameHint': 'e.g. Gold Foil, Silver',
    'admin.field.printRun': 'Print run',
    'admin.field.printRunHint': 'Leave empty if unnumbered',
    'admin.parallel.cleared': 'Base card cleared: series changed.',
    'admin.parallel.locked_one': "This card has 1 parallel, so it can't be a parallel of another card.",
    'admin.parallel.locked_other': "This card has {n} parallels, so it can't be a parallel of another card.",
    'admin.parallel.printRunMin': 'Print run must be at least 1. Leave it blank if unlimited.',
    'card.detail.rarity': 'Rarity',
    'card.detail.series': 'Series',
    'card.detail.seriesLabel': 'Series: ',
    'card.detail.loadFailed': "Couldn't load this card",
    'card.detail.bodyTitle': 'About',
    'card.body.codeBlock': 'Code block',
    'card.detail.bodyExpand': 'Show more',
    'card.detail.bodyCollapse': 'Show less',
    'card.lightbox.open': 'View large image: {name}',
    'card.lightbox.failed': 'Image failed to load',
    'card.adjacent.aria': 'Previous and next card',
    'card.adjacent.prev': 'Previous',
    'card.adjacent.next': 'Next',
    'series.releases.title': 'Releases',
    'series.releases.more': 'View release calendar →',
    'release.source': 'Source',
    'admin.card.body': 'About (Markdown)',
    'a11y.newTab': '(opens in new tab)',
    'state.close': 'Close',
    'card.detail.commentsTitle': 'Comments',
    'card.detail.loginToComment': 'Sign in to leave a comment',
    'card.detail.commentSubmit': 'Post comment',
    'card.detail.commentEmpty': 'No comments yet — be the first to chime in',
    'card.detail.commentsLoadFailed': "Couldn't load comments",
    'card.detail.commentSubmitting': 'Posting…',
    'card.detail.commentPlaceholder': 'Share your thoughts about this card…',
    'card.detail.commentDelete': 'Delete',
    'card.detail.commentDeleteAria': 'Delete comment by @{user}',
    'card.detail.confirmDeleteComment': 'Delete this comment?',
    'card.detail.commentDeleteCancel': 'Cancel',
    'card.detail.commentDeleting': 'Deleting…',
    'card.detail.commentDeleted': 'Comment deleted',
    'card.detail.commentDeleteFailed': "Couldn't delete. Try again.",
    'card.detail.commentDeleteForbidden': "You can't delete this comment",
    'card.detail.commentRateLimited': 'Too many comments. Try again later.',
    'comments.mentionHint': 'Type @username to notify someone.',
    'comment.reply': 'Reply',
    'comment.replyAria': 'Reply to @{user}',
    'comment.repliesListAria': 'Replies to @{user}',
    'comment.replyCount_one': '{count} reply',
    'comment.replyCount_other': '{count} replies',
    'comment.reply.submit': 'Reply',
    'comment.reply.submitting': 'Sending…',
    'comment.reply.cancel': 'Cancel',
    'comment.reply.posted': 'Reply posted',
    'comment.reply.empty': 'Write something before replying',
    'comment.reply.parentGone': "This comment was removed, so you can't reply.",
    'comment.reply.showMore_one': 'Show {count} more reply',
    'comment.reply.showMore_other': 'Show {count} more replies',
    'comment.reply.loaded_one': 'Loaded {count} reply',
    'comment.reply.loaded_other': 'Loaded {count} replies',
    'comment.reply.loadFailed': "Couldn't load replies",
    'comment.reply.confirmDelete': 'Delete this reply?',
    'comment.reply.deleted': 'Reply deleted',
    'comment.confirmDeleteWithReplies_one': 'Delete this comment? Its {count} reply will be deleted too.',
    'comment.confirmDeleteWithReplies_other': 'Delete this comment? Its {count} replies will be deleted too.',
    'comment.deletedWithReplies_one': 'Comment and {count} reply deleted',
    'comment.deletedWithReplies_other': 'Comment and {count} replies deleted',
    'error.app.COMMENT_PARENT_GONE': "This comment was removed, so you can't reply.",
    'auth.register.title': 'Create account',
    'auth.register.subtitle': 'Join the Cardhub community and discuss cards',
    'auth.login.title': 'Sign in',
    'auth.login.subtitle': 'Welcome back',
    'auth.login.unauthorized': 'The account or password is incorrect.',
    'auth.register.conflict': 'That email or username is already in use. Try another.',
    'auth.fields.email': 'Email',
    'auth.fields.username': 'Username',
    'auth.fields.password': 'Password',
    'auth.fields.identifier': 'Email or username',
    'auth.actions.register': 'Sign up',
    'auth.actions.login': 'Sign in',
    'auth.actions.toLogin': 'Already have an account? Sign in',
    'auth.actions.toRegister': 'New here? Create an account',
    'auth.actions.submitting': 'Submitting…',
    'auth.errors.password.short': 'Password must be at least 8 characters',
    'auth.errors.username.invalid': 'Username can only contain letters, digits, _ and -',
    'auth.errors.email.invalid': 'Invalid email address',
    'auth.errors.email.tooLong': 'Email can be at most 128 characters',
    'auth.errors.identifier.tooLong': 'Email or username can be at most 128 characters',
    'auth.errors.required': 'Please fill in all required fields',
    'auth.notice.signedOutAll': "You've been signed out everywhere. Sign in again.",
    'auth.notice.sessionExpired': 'Your session has ended. Sign in again.',
    'search.placeholder': 'Search cards or series…',
    'search.empty': 'No matching cards or series',
    'search.results': 'Search results',
    'search.results.title': 'Results for “{query}”',
    'search.headerLabel': 'Search Cardhub',
    'search.groupCards': 'Cards',
    'search.groupSeries': 'Series',
    'search.viewAllFor': 'See all results for “{query}”',
    'search.syntaxLabel': 'Try:',
    'search.trySyntax': 'Search for “{example}”',
    'search.syntaxHelp': 'r: rarity, s: series, c: card number, y: release year, OR for either, - to exclude',
    'search.unsupportedPrefix': "“{token}” isn't supported. Use r: (rarity), s: (series), c: (card number), or y: (release year).",
    'search.ignoredYear': 'Ignored “{token}”: use a 4-digit year, like y:2024.',
    'search.ignoredCardNumber': 'Ignored “{token}”: card numbers are up to 20 characters.',
    'series.list.search': 'Search this set',
    'series.list.searchPlaceholder': 'Name or number',
    'series.list.subset': 'Subset',
    'series.list.rarity': 'Rarity',
    'series.list.sort': 'Sort',
    'series.list.any': 'All',
    'series.list.sort.number': 'Number',
    'series.list.sort.name': 'Name',
    'series.list.sort.rarity': 'Rarity',
    'series.list.sort.created': 'Date added',
    'series.list.filters': 'Filters',
    'series.list.filtersCount': 'Filters ({n})',
    'series.list.total': '{count} cards',
    'series.list.total_one': '{count} card',
    'series.list.total_other': '{count} cards',
    'series.list.found': '{count} cards found',
    'series.list.found_one': '{count} card found',
    'series.list.found_other': '{count} cards found',
    'series.list.empty': 'No cards in this set yet.',
    'series.list.noMatch': 'No cards match these filters.',
    'series.list.clear': 'Clear filters',
    'series.list.searchLandmark': 'Filter cards in this set',
    'pagination.label': 'Pagination',
    'pagination.prev': 'Previous',
    'pagination.next': 'Next',
    'pagination.page': 'Page {page}',
    'pagination.of': 'Page {page} of {count}',
    'search.invalidRarity': "There's no “{value}” rarity. Use common, rare, epic, or legendary.",
    'search.filterRarity': 'Rarity',
    'search.filterSeries': 'Series',
    'search.filterAny': 'Any',
    'search.clearFilters': 'Clear filters',
    'search.prompt': 'Type a card or series name to start',
    'search.cardsHeading': 'Cards ({count})',
    'search.cardsHeading_one': 'Card ({count})',
    'search.cardsHeading_other': 'Cards ({count})',
    'search.seriesHeading': 'Series ({count})',
    'search.summary.cards': '{count} cards',
    'search.summary.cards_one': '{count} card',
    'search.summary.cards_other': '{count} cards',
    'search.summary.series': '{count} series',
    'search.resultsSummary': '{results}. Found {cards} and {series}.',
    'form.clear': 'Clear',
    'form.searching': 'Searching…',
    'form.searchFailed': 'Search failed',
    'form.resultsCount': '{count} results',
    'form.resultsCount_one': '{count} result',
    'form.resultsCount_other': '{count} results',
    'state.loading': 'Loading…',
    'state.error': 'Failed to load',
    'state.notFound': 'Not found',
    'state.retry': 'Retry',
    'state.retrying': 'Retrying…',
    'state.crashTitle': 'Something went wrong',
    'state.crashBody': 'Try again, or go back home.',
    'state.crashHome': 'Back home',
    'forum.list.title': 'Community forum',
    'forum.list.subtitle': 'Discuss cards, deck builds, and patch notes',
    'forum.list.empty': 'No topics yet — start the first conversation',
    'forum.list.newTopic': 'New topic',
    'forum.list.loginToPost': 'Sign in to post a topic',
    'forum.list.loadMore': 'Load more',
    'forum.list.replyCount': '{count} replies',
    'forum.list.replyCount_one': '{count} reply',
    'forum.list.replyCount_other': '{count} replies',
    'forum.badge.pinned': 'Pinned',
    'forum.detail.repliesTitle': 'Replies ({count})',
    'forum.detail.repliesTitle_one': 'Reply ({count})',
    'forum.detail.repliesTitle_other': 'Replies ({count})',
    'forum.detail.noReplies': 'No replies yet — be the first to chime in',
    'forum.detail.replyLabel': 'Write a reply',
    'forum.detail.replyPlaceholder': 'Add to the discussion…',
    'forum.detail.replySubmit': 'Post reply',
    'forum.detail.replySubmitting': 'Posting…',
    'forum.detail.markdownNote': 'Markdown + GFM tables / task lists supported',
    'forum.detail.loginToReply': 'Sign in to reply',
    'forum.detail.delete': 'Delete',
    'forum.detail.deleteTopicAria': 'Delete this topic',
    'forum.detail.deleteReplyAria': 'Delete reply by @{user}',
    'forum.detail.deleteCancel': 'Cancel',
    'forum.detail.deleting': 'Deleting…',
    'forum.detail.topicDeleted': 'Topic deleted',
    'forum.detail.replyDeleted': 'Reply deleted',
    'forum.detail.deleteFailed': "Couldn't delete. Try again.",
    'forum.detail.deleteTopicForbidden': "You can't delete this topic",
    'forum.detail.deleteReplyForbidden': "You can't delete this reply",
    'forum.detail.edit': 'Edit',
    'forum.detail.editAria': 'Edit this topic',
    'forum.detail.editableUntil': 'Editable until {time}',
    'forum.detail.edited': 'Edited',
    'forum.detail.topicEdited': 'Topic updated',
    'forum.detail.pin': 'Pin',
    'forum.detail.unpin': 'Unpin',
    'forum.detail.pinning': 'Pinning…',
    'forum.detail.unpinning': 'Unpinning…',
    'forum.detail.pinned': 'Pinned. This topic now appears first in the list.',
    'forum.detail.unpinned': 'Unpinned',
    'forum.detail.pinFailed': "Couldn't update. Try again.",
    'forum.detail.pinForbidden': 'Only admins can pin topics',
    'forum.detail.confirmDelete': 'Delete this topic? This cannot be undone.',
    'forum.detail.confirmDeleteReply': 'Delete this reply? This cannot be undone.',
    'forum.detail.loadMoreReplies': 'Load more replies',
    'forum.detail.repliesLoaded': 'Loaded {count} replies',
    'forum.detail.repliesLoaded_one': 'Loaded {count} reply',
    'forum.detail.repliesLoaded_other': 'Loaded {count} replies',
    'forum.detail.allRepliesShown': 'All replies shown',
    'forum.detail.loadMoreFailed': "Couldn't load replies",
    'forum.new.title': 'Start a new topic',
    'forum.new.subtitle': 'Markdown supported. You have 5 minutes after posting to edit.',
    'forum.new.titleLabel': 'Title',
    'forum.new.titlePlaceholder': 'Summarise your topic in one line',
    'forum.new.bodyLabel': 'Body',
    'forum.new.bodyPlaceholder': 'Write your topic here. Markdown is supported.',
    'forum.new.markdownHint': 'Headings, lists, tables, code blocks — standard Markdown',
    'forum.new.showPreview': 'Preview',
    'forum.new.hidePreview': 'Back to editing',
    'forum.new.previewEmpty': 'Body is empty — nothing to preview yet',
    'forum.new.publish': 'Post topic',
    'forum.new.publishing': 'Publishing…',
    'forum.new.cancel': 'Cancel',
    'forum.edit.title': 'Edit topic',
    'forum.edit.remaining': '{minutes} min left to edit',
    'forum.edit.remainingUnderMinute': 'Less than a minute left to edit',
    'forum.edit.save': 'Save changes',
    'forum.edit.saving': 'Saving…',
    'forum.edit.cancel': 'Cancel',
    'forum.edit.saveFailed': "Couldn't save. Try again.",
    'forum.edit.expired': "The 5-minute edit window has closed, so your changes can't be saved. Your text is still below — copy it if you want to delete the topic and post again.",
    'forum.edit.notAllowed': 'This topic can no longer be edited',
    'forum.edit.backToTopic': 'Back to topic',
    'trade.list.title': 'Trade board',
    'trade.list.subtitle': 'Player-posted listings — Cardhub only relays information',
    'trade.list.disclaimer': 'Cardhub does not facilitate trades or guarantee any funds. Contact off-platform and verify independently.',
    'trade.list.empty': 'No listings yet',
    'trade.list.publish': 'Post listing',
    'trade.list.loginToPublish': 'Sign in to post a listing',
    'trade.list.filterAll': 'All',
    'trade.list.filterSell': 'Selling',
    'trade.list.filterBuy': 'Buying',
    'trade.list.cardFilter': 'Filter by card',
    'trade.list.loadMore': 'Load more',
    'trade.list.kindSell': 'Sell',
    'trade.list.kindBuy': 'Buy',
    'trade.list.statusOpen': 'Open',
    'trade.list.statusClosed': 'Closed',
    'trade.list.cardDelisted': 'Card removed',
    'trade.list.contact': 'Contact',
    'trade.list.note': 'Notes',
    'trade.list.priceFree': 'Negotiable',
    'trade.list.photos': 'Photos',
    'trade.list.photoOpen': 'View photo {index} of {total} (opens in new tab)',
    'trade.list.photoFallback': 'Photo {index}',
    'trade.list.contactSignIn': 'Sign in to see contact info',
    'trade.publish.title': 'Publish a listing',
    'trade.publish.kind': 'Listing type',
    'trade.publish.kindSell': 'Selling',
    'trade.publish.kindBuy': 'Buying',
    'trade.publish.card': 'Card',
    'trade.publish.cardPlaceholder': 'Search by card name…',
    'trade.publish.cardChange': 'Change',
    'trade.publish.cardNotFound': "Couldn't find that card. Pick another one.",
    'trade.publish.price': 'Price (optional)',
    'trade.publish.currency': 'Currency',
    'trade.publish.imageUrls': 'Photo links (optional)',
    'trade.publish.imageUrlsHint': 'One https link per line, up to 4',
    'trade.publish.imagePreview': 'Photo preview',
    'trade.publish.contact': 'Contact info (WeChat / QQ / email…)',
    'trade.publish.contactHintSignedIn': 'Only signed-in users can see this',
    'trade.publish.note': 'Notes (optional, max 500 chars)',
    'trade.publish.submit': 'Post listing',
    'trade.publish.submitting': 'Posting…',
    'trade.publish.cancel': 'Cancel',
    'trade.publish.notSpecified': 'Not specified',
    'trade.publish.variantNote': 'Edition note (optional)',
    'trade.publish.variantNotePlaceholder': 'e.g. foil, first edition, signed',
    'trade.publish.error.cardRequired': 'Pick a card',
    'trade.publish.error.price': 'Enter a price between 0 and 9,999,999,999.99',
    'trade.publish.error.imageUrl': 'Image links must start with https://',
    'trade.publish.error.tooManyImages': 'Up to 4 photos',
    'trade.publish.error.imageTooLong': 'Image links can be at most 2048 characters',
    'trade.publish.error.priceTooLong': 'Price can be at most 64 characters',
    'trade.publish.error.contact': 'Contact must be 2–200 characters',
    'trade.publish.rateLimited': 'Too many listings. Try again later.',
    'trade.publish.disclaimer': 'Cardhub does not facilitate trades or guarantee any funds. Contact off-platform and verify independently. Do not post illegal or infringing content.',
    'trade.condition.label': 'Condition',
    'trade.condition.NEAR_MINT': 'Near mint',
    'trade.condition.LIGHTLY_PLAYED': 'Lightly played',
    'trade.condition.MODERATELY_PLAYED': 'Moderately played',
    'trade.condition.HEAVILY_PLAYED': 'Heavily played',
    'trade.condition.DAMAGED': 'Damaged',
    'trade.language.label': 'Language',
    'trade.language.ZH': 'Chinese',
    'trade.language.EN': 'English',
    'trade.language.JA': 'Japanese',
    'trade.language.OTHER': 'Other',
    'trade.filter.any': 'Any',
    'trade.filter.toggle': 'Filters & sort',
    'trade.filter.toggleCount': 'Filters & sort ({count})',
    'trade.filter.toggleCount_one': 'Filter & sort ({count})',
    'trade.filter.toggleCount_other': 'Filters & sort ({count})',
    'trade.filter.priceRange': 'Price range',
    'trade.filter.minPrice': 'Min price',
    'trade.filter.maxPrice': 'Max price',
    'trade.filter.priceInvalid': "Min price can't be higher than max",
    'trade.filter.priceNeedsCurrency': 'Choose a currency to set a price range',
    'trade.filter.clear': 'Clear {label}',
    'trade.filter.clearAll': 'Clear all',
    'trade.filter.invalid': "These filters aren't valid",
    'trade.filter.clearInvalid': 'Clear filters',
    'trade.filter.empty': 'No listings match these filters',
    'trade.sort.label': 'Sort',
    'trade.sort.newest': 'Newest',
    'trade.sort.price_asc': 'Price: low to high',
    'trade.sort.price_desc': 'Price: high to low',
    'trade.sort.currencyHint': 'Only listings priced in {currency}. Negotiable and other currencies are left out.',
    'trade.detail.byCardTitle': 'Listings for this card',
    'trade.detail.byCardEmpty': 'No listings for this card yet',
    'trade.detail.byCardLoadFailed': "Couldn't load listings",
    'trade.detail.byCardPublish': 'Publish a listing',
    'trade.close': 'Close listing',
    'trade.closeAria': 'Close this listing',
    'trade.confirmClose': "Close this listing? You can't reopen it.",
    'trade.closeCancel': 'Cancel',
    'trade.closing': 'Closing…',
    'trade.closed': 'Listing closed',
    'trade.closeFailed': "Couldn't close. Try again.",
    'trade.closeForbidden': 'You can only close your own listings',
    'me.title': 'My account',
    'me.sectionsNav': 'Account sections',
    'me.joinedAt': 'Joined {date}',
    'me.roleAdmin': 'Admin',
    'me.stats.listings': 'Listings',
    'me.stats.topics': 'Topics',
    'me.stats.replies': 'Replies',
    'me.stats.comments': 'Comments',
    'me.listings.title': 'My listings',
    'me.listings.empty': "You haven't posted any listings yet",
    'me.topics.title': 'My topics',
    'me.topics.empty': "You haven't started any topics yet",
    'me.comments.title': 'My comments',
    'me.comments.empty': "You haven't commented on any cards yet",
    'me.comments.onCard': 'On {card}',
    'me.loadMore': 'Load more',
    'collection.title': 'My collection',
    'collection.own': 'I have it',
    'collection.want': 'Want',
    'collection.progress': '{owned} of {total}',
    'collection.empty': 'Nothing here yet. Tap "I have it" or "Want" on a card page.',
    'collection.sectionList': 'Cards',
    'collection.sectionProgress': 'Series progress',
    'collection.filter': 'Filter',
    'collection.filterAll': 'All',
    'collection.filterOwned': 'I have it',
    'collection.filterWanted': 'Want',
    'collection.badgeOwned': 'Have ×{count}',
    'collection.badgeWanted': 'Want',
    'collection.retry': 'Try again',
    'collection.complete': 'Complete',
    'collection.none': 'None',
    'collection.share': 'Share',
    'collection.quantity': 'Quantity',
    'collection.copied': 'Link copied',
    'collection.copyFailed': "Couldn't copy. Copy the link from the address bar.",
    'collection.signInHint': 'Sign in to track your collection.',
    'collection.statusLoadFailed': "Couldn't load your collection status.",
    'me.security.title': 'Security',
    'me.security.password': 'Password',
    'me.security.passwordHint': 'After you change it, other devices must sign in again with the new password.',
    'auth.legacyPassword.notice': 'Your password was set under older security rules. Change it once to fully protect your account.',
    'auth.legacyPassword.action': 'Change password',
    'auth.legacyPassword.later': 'Later',
    'auth.legacyPassword.meHint': 'We recommend changing your password: it was set under older security rules.',
    'me.security.changePassword': 'Change password',
    'me.security.signOutAll': 'Sign out everywhere',
    'me.security.signOutAllHint': 'Signs out every device, including this one.',
    'me.password.title': 'Change password',
    'me.password.subtitle': "You'll stay signed in here. Other devices will be signed out.",
    'me.password.current': 'Current password',
    'me.password.new': 'New password',
    'me.password.newHint': '8 to 128 characters',
    'me.password.confirm': 'Confirm new password',
    'me.password.show': 'Show {field}',
    'me.password.hide': 'Hide {field}',
    'me.password.cancel': 'Cancel',
    'me.password.submit': 'Change password',
    'me.password.submitting': 'Changing…',
    'me.password.changed': 'Password changed. Other devices have been signed out.',
    'me.password.errors.currentRequired': 'Enter your current password',
    'me.password.errors.wrong': "That's not your current password",
    'me.password.errors.tooLong': 'Password can be at most 128 characters',
    'me.password.errors.same': 'Choose a password different from your current one',
    'me.password.errors.confirmRequired': 'Enter the new password again',
    'me.password.errors.mismatch': "The passwords don't match",
    'me.password.errors.rateLimited': 'Too many attempts. Try again later.',
    'me.password.errors.failed': "Couldn't change your password. Try again.",
    'me.signOutAll.title': 'Sign out everywhere?',
    'me.signOutAll.body': "Every device will be signed out, including this one. You'll need your password to sign in again. Anything you haven't posted won't be saved.",
    'me.signOutAll.confirm': 'Sign out everywhere',
    'me.signOutAll.pending': 'Signing out…',
    'me.signOutAll.cancel': 'Cancel',
    'me.signOutAll.failed': "Couldn't sign out. Try again.",
    'report.button': 'Report',
    'report.title': 'Report content',
    'report.reasonLabel': 'Tell us what is wrong',
    'report.reasonPlaceholder': 'Describe the violation, reason, or evidence',
    'report.submit': 'Submit report',
    'report.submitting': 'Submitting…',
    'report.cancel': 'Cancel',
    'report.success': 'Report received — thanks for helping out',
    'report.loginRequired': 'Sign in to report content',
    'reports.title': 'Reports queue',
    'reports.subtitle': 'Admin queue for community and trade moderation reports',
    'reports.loginRequired': 'Sign in to view the reports queue',
    'reports.adminOnly': 'Only admins can view the reports queue',
    'reports.empty': 'No reports match the current filter',
    'reports.loadMore': 'Load more',
    'reports.filterAll': 'All',
    'reports.filterPending': 'Pending',
    'reports.filterResolved': 'Resolved',
    'reports.openTarget': 'Open target content',
    'reports.targetMissing': 'The target content no longer exists; this report is kept for audit history',
    'reports.target.listing': 'Trade listing',
    'reports.target.topic': 'Forum topic',
    'reports.target.reply': 'Forum reply',
    'reports.target.comment': 'Card / series comment',
    'reports.resolve.noteLabel': 'Resolution note (optional)',
    'reports.resolve.notePlaceholder': 'e.g. Violation confirmed',
    'reports.resolve.markResolved': 'Mark resolved',
    'reports.resolve.removeTarget': 'Remove content & resolve',
    'reports.resolve.closeTarget': 'Close listing & resolve',
    'reports.resolve.confirmRemove': "This can't be undone. Other pending reports on this content will be resolved too.",
    'reports.resolve.confirmClose': 'This listing will be closed. Other pending reports on it will be resolved too.',
    'reports.resolve.confirmRemoveAction': 'Delete',
    'reports.resolve.confirmCloseAction': 'Close listing',
    'reports.resolve.cancel': 'Cancel',
    'reports.resolve.submitting': 'Resolving…',
    'reports.resolve.successMarked': 'Marked as resolved',
    'reports.resolve.successRemoved': 'Content removed. Reports resolved.',
    'reports.resolve.successClosed': 'Listing closed. Reports resolved.',
    'reports.resolve.failed': "Couldn't resolve. Try again.",
    'reports.resolve.forbidden': "You can't resolve this report",
    'reports.resolve.resolvedBy': 'Resolved by',
    'reports.resolve.resolvedAt': 'Resolved at',
    'reports.resolve.resolution': 'Note',
    'reports.resolve.deletedUser': 'Deleted user',
    'admin.loginRequired': 'Sign in with an admin account',
    'admin.adminOnly': 'Only admins can manage content',
    'admin.users.title': 'Users',
    'admin.users.subtitle': 'Find users and ban or unban accounts',
    'admin.users.search': 'Search by username or email',
    'admin.users.filterAll': 'All',
    'admin.users.filterActive': 'Active',
    'admin.users.filterBanned': 'Banned',
    'admin.users.total_one': '{count} user',
    'admin.users.total_other': '{count} users',
    'admin.users.caption': 'Users',
    'admin.users.colUser': 'Username',
    'admin.users.colEmail': 'Email',
    'admin.users.colStatus': 'Status',
    'admin.users.colJoined': 'Joined',
    'admin.users.colContent': 'Posts',
    'admin.users.contentBreakdown': '{topics} topics · {replies} replies · {comments} comments · {listings} listings',
    'admin.users.statusActive': 'Active',
    'admin.users.statusBanned': 'Banned',
    'admin.users.bannedMeta': '{time} · @{admin}',
    'admin.users.noMatch': 'No users match',
    'admin.users.clearFilters': 'Clear filters',
    'admin.users.gone': 'This user no longer exists. The list has been refreshed.',
    'admin.users.ban': 'Ban',
    'admin.users.unban': 'Unban',
    'admin.users.history': 'History',
    'admin.users.banAria': 'Ban @{user}',
    'admin.users.unbanAria': 'Unban @{user}',
    'admin.users.historyAria': 'View audit history for @{user}',
    'admin.ban.title': 'Ban @{user}?',
    'admin.ban.body': "They'll be signed out on every device right away. After signing back in they can only browse: no comments, topics, replies, listings or reports. Existing posts stay. You can unban them at any time.",
    'admin.ban.reason': 'Reason (required)',
    'admin.ban.reasonHint': "Only admins can see this. It's saved to the audit log.",
    'admin.ban.reasonRequired': 'Enter a reason',
    'admin.ban.confirm': 'Ban',
    'admin.ban.pending': 'Banning…',
    'admin.ban.done': "Banned @{user}. They've been signed out everywhere.",
    'admin.ban.cannotAdmin': "Admins can't be banned",
    'admin.ban.cannotSelf': "You can't ban yourself",
    'admin.ban.failed': "Couldn't ban this user. Try again.",
    'admin.unban.title': 'Unban @{user}?',
    'admin.unban.body': "They'll be able to comment, post, reply, list and report again. Devices signed out by the ban need to sign in again.",
    'admin.unban.reason': 'Reason (required)',
    'admin.unban.confirm': 'Unban',
    'admin.unban.pending': 'Unbanning…',
    'admin.unban.done': 'Unbanned @{user}',
    'admin.unban.failed': "Couldn't unban this user. Try again.",
    'admin.audit.title': 'Audit log',
    'admin.audit.subtitle': "Bans, unbans, content removals and report handling. Entries can't be edited.",
    'admin.audit.caption': 'Audit entries',
    'admin.audit.filterLabel': 'Action',
    'admin.audit.filterAll': 'All actions',
    'admin.audit.userFilter': 'Target: @{user}',
    'admin.audit.clearUser': 'Clear target filter',
    'admin.audit.colTime': 'Time',
    'admin.audit.colActor': 'Admin',
    'admin.audit.colAction': 'Action',
    'admin.audit.colTarget': 'Target',
    'admin.audit.colReason': 'Reason',
    'admin.audit.action.USER_BAN': 'Ban',
    'admin.audit.action.USER_UNBAN': 'Unban',
    'admin.audit.action.CONTENT_DELETE': 'Remove content',
    'admin.audit.action.REPORT_RESOLVE': 'Handle report',
    'admin.audit.target.TOPIC': 'Topic',
    'admin.audit.target.REPLY': 'Reply',
    'admin.audit.target.COMMENT': 'Comment',
    'admin.audit.target.LISTING': 'Listing',
    'admin.audit.target.CARD': 'Card',
    'admin.audit.target.SERIES': 'Series',
    'admin.audit.target.REPORT': 'Report',
    'admin.audit.owner': 'By @{user}',
    'admin.audit.noReason': 'Not given',
    'admin.audit.empty': 'No audit entries yet',
    'admin.audit.noMatch': 'No entries match',
    'ban.banner.title': 'Your account is banned',
    'ban.banner.body': "You can still browse and manage your listings and account settings, but you can't comment, post topics or replies, create listings, or report.",
    'ban.cannotComment': "Your account is banned, so you can't comment.",
    'ban.cannotReply': "Your account is banned, so you can't reply.",
    'ban.cannotPost': "Your account is banned, so you can't post topics.",
    'ban.cannotEdit': "Your account is banned, so you can't edit topics.",
    'ban.cannotTrade': "Your account is banned, so you can't create listings.",
    'ban.actionBlocked': "Your account is banned. This action wasn't completed.",
    'ban.backToForum': 'Back to forum',
    'ban.backToTrade': 'Back to trading board',
    'admin.catalog.title': 'Catalog',
    'admin.catalog.subtitle': 'Manage series and cards. Changes go live as soon as you save.',
    'admin.series.new': 'New series',
    'admin.series.edit': 'Edit series',
    'admin.series.import': 'Import JSON',
    'admin.series.caption': 'All series',
    'admin.series.empty': 'No series yet. Create one, or import a JSON file.',
    'admin.releases.title': 'Releases',
    'admin.releases.new': 'New release',
    'admin.releases.edit': 'Edit release',
    'admin.releases.empty': 'No releases yet.',
    'admin.releases.deleteTitle': 'Delete this release?',
    'admin.releases.deleteBody': '"{title}" will be removed from the calendar. The series stays.',
    'admin.releases.saved': 'Saved',
    'admin.releases.loadError': "Couldn't load releases.",
    'admin.releases.missing': 'This release no longer exists.',
    'admin.releases.seriesMissing': "That series doesn't exist.",
    'admin.releases.categoryMissing': "That category doesn't exist.",
    'admin.releases.monthOnly': 'Month only',
    'admin.releases.dateHint': 'Format: 2026-11-06',
    'admin.releases.dateHintMonth': 'Format: 2026-11',
    'admin.releases.region': 'Region',
    'admin.releases.regionAny': 'Any',
    'admin.releases.series': 'Linked series',
    'admin.releases.seriesPlaceholder': 'Search by series name',
    'admin.releases.seriesEmpty': 'No matching series',
    'admin.releases.categoryNone': 'Any',
    'admin.releases.note': 'Note',
    'admin.releases.sourceUrl': 'Source link',
    'admin.releases.sourceHint': 'Must start with https://. The server does not open this address.',
    'admin.releases.col.date': 'Date',
    'admin.releases.col.region': 'Region',
    'admin.releases.col.series': 'Series',
    'admin.col.cover': 'Cover',
    'admin.col.image': 'Art',
    'admin.col.title': 'Title',
    'admin.col.name': 'Name',
    'admin.col.slug': 'Slug',
    'admin.col.cards': 'Cards',
    'admin.col.rarity': 'Rarity',
    'admin.col.updated': 'Updated',
    'admin.col.actions': 'Actions',
    'admin.action.edit': 'Edit',
    'admin.action.view': 'View on site',
    'admin.action.delete': 'Delete',
    'admin.action.editAria': 'Edit “{name}”',
    'admin.action.viewAria': 'View “{name}” on site (opens in new tab)',
    'admin.action.deleteAria': 'Delete “{name}”',
    'admin.cancel': 'Cancel',
    'admin.deleting': 'Deleting…',
    'admin.deleteFailed': "Couldn't delete. Try again.",
    'admin.deleteReason.label': 'Reason (optional, admins only)',
    'admin.deleteReason.count': '{n}/500',
    'admin.category.deleteBody': "Its series stay, but won't belong to a category.",
    'admin.subset.deleteBody_one': 'Its {count} cards stay and move to Other cards.',
    'admin.subset.deleteBody_other': 'Its {count} cards stay and move to Other cards.',
    'admin.catalog.seriesTab': 'Series',
    'admin.catalog.categoriesTab': 'Categories',
    'admin.category.new': 'New category',
    'admin.category.edit': 'Edit category',
    'admin.category.empty': 'No categories yet',
    'admin.category.created': 'Created category {name}',
    'admin.category.deleted': 'Deleted category {name}',
    'admin.category.deleteTitle': 'Delete category {name}?',
    'admin.field.category': 'Category',
    'admin.field.categoryNone': 'No category',
    'admin.field.releaseDate': 'Release date',
    'admin.field.cardNumber': 'Card number',
    'admin.field.cardNumberHint': 'Up to 20 characters. Leave empty when there is no number. The site shows it as #001.',
    'admin.field.subset': 'Subset',
    'admin.field.subsetNone': 'Other cards',
    'admin.field.sortOrder': 'Sort order',
    'admin.subset.title': 'Subsets',
    'admin.subset.new': 'New subset',
    'admin.subset.edit': 'Edit subset',
    'admin.subset.empty': 'This series has no subsets yet',
    'admin.subset.saved': 'Subset saved',
    'admin.subset.deleted': 'Deleted subset {name}',
    'admin.subset.kindBase': 'Base',
    'admin.subset.kindInsert': 'Insert',
    'admin.subset.deleteTitle': 'Delete subset {name}?',
    'admin.series.forceSubsets_one': 'and {count} subset.',
    'admin.series.forceSubsets_other': 'and {count} subsets.',
    'admin.series.confirmDelete': "Delete series “{title}”? This can't be undone.",
    'admin.series.forceTitle': 'Delete “{title}” and all its cards',
    'admin.series.forceTitleSeriesComments': 'Delete “{title}” and its series comments',
    'admin.series.forceBody': "This also permanently deletes {cards} in this series and {comments} on them. Trade listings for these cards stay, but will show as “Card removed”. This can't be undone.",
    'admin.series.forceBodySeriesComments': "This permanently deletes the {comments} on this series. This can't be undone.",
    'admin.count.cards_one': '{count} card',
    'admin.count.cards_other': '{count} cards',
    'admin.count.comments_one': '{count} comment',
    'admin.count.comments_other': '{count} comments',
    'admin.count.seriesComments_one': '{count} series comment',
    'admin.count.seriesComments_other': '{count} series comments',
    'admin.series.forceConfirmLabel': 'Type the series slug “{slug}” to confirm',
    'admin.series.forceConfirm': 'Delete permanently',
    'admin.series.created': 'Created series “{title}”',
    'admin.series.deleted': 'Deleted series “{title}”',
    'admin.series.deletedWithCards': 'Deleted series “{title}” and {cards}',
    'admin.cards.new': 'New card',
    'admin.cards.edit': 'Edit card',
    'admin.cards.caption': 'Cards in {series}',
    'admin.cards.filter': 'Filter by name or slug',
    'admin.cards.empty': 'No cards in this series yet',
    'admin.cards.confirmDelete': "Delete “{name}”? Its comments are deleted too, and listings for it will show as “Card removed”. This can't be undone.",
    'admin.cards.created': 'Created card “{name}”',
    'admin.cards.deleted': 'Deleted card “{name}”',
    'admin.cards.saveAndNext': 'Save and add another',
    'admin.form.create': 'Create',
    'admin.form.save': 'Save changes',
    'admin.form.saving': 'Saving…',
    'admin.saved': 'Changes saved',
    'admin.saveFailed': "Couldn't save. Try again.",
    'admin.field.slug': 'Slug',
    'admin.field.slugHint': "Lowercase letters, numbers and hyphens, e.g. celestial-dawn. Can't be changed later.",
    'admin.field.slugLocked': "Can't be changed after creation (URLs and listings depend on it)",
    'admin.field.title': 'Title',
    'admin.field.name': 'Name',
    'admin.field.description': 'Description',
    'admin.field.series': 'Series',
    'admin.field.rarity': 'Rarity',
    'admin.field.coverUrl': 'Cover image URL',
    'admin.field.imageUrl': 'Card art URL',
    'admin.field.imageHint': 'An https:// image link. Leave empty for the default gradient. Recommended ratio {ratio}.',
    'admin.field.preview': 'Preview',
    'admin.field.previewFailed': "This image won't load, so the site will show the default gradient. Check the link, or make sure the host allows hotlinking.",
    'admin.error.required': 'Required',
    'admin.error.slugFormat': 'Slugs can only use lowercase letters, numbers and hyphens',
    'admin.error.slugTaken': 'This slug is already taken',
    'admin.error.imageUrl': 'Use an https:// image link, or leave it empty',
    'admin.error.imageTooLong': 'Image links can be at most {max} characters',
    'admin.error.rarity': 'Must be common, rare, epic, or legendary',
    'admin.error.invalidType': 'Invalid value',
    'admin.error.slugDuplicateInFile': 'Duplicate slug in this file',
    'admin.error.seriesNotFound': 'Series not found',
    'admin.error.unknown': 'Something went wrong: {message}',
    'admin.attrs.label': 'Attributes',
    'admin.attrs.empty': 'No attributes yet',
    'admin.attrs.add': 'Add attribute',
    'admin.attrs.keyAria': 'Attribute name, row {n}',
    'admin.attrs.typeAria': 'Type, row {n}',
    'admin.attrs.valueAria': 'Value, row {n}',
    'admin.attrs.typeText': 'Text',
    'admin.attrs.typeNumber': 'Number',
    'admin.attrs.typeBool': 'Yes / No',
    'admin.attrs.true': 'Yes',
    'admin.attrs.false': 'No',
    'admin.attrs.remove': 'Remove attribute “{key}”',
    'admin.attrs.removeRow': 'Remove row {n}',
    'admin.attrs.errorKey': 'Enter a name',
    'admin.attrs.errorDuplicate': 'Duplicate name',
    'admin.attrs.errorNumber': 'Enter a number',
    'admin.attrs.errorTooMany': 'At most {max} attributes',
    'admin.attrs.errorKeyLength': 'Names can be at most {max} characters',
    'admin.attrs.errorValueLength': 'Values can be at most {max} characters',
    'admin.attrs.atLimit': 'This card has {count} attributes (limit {max})',
    'admin.attrs.atLimit_one': 'This card has {count} attribute (limit {max})',
    'admin.attrs.atLimit_other': 'This card has {count} attributes (limit {max})',
    'admin.attrs.colKey': 'Name',
    'admin.attrs.colType': 'Type',
    'admin.attrs.colValue': 'Value',
    'admin.unsaved.title': 'Discard unsaved changes?',
    'admin.unsaved.body': "If you leave this page, your changes won't be saved.",
    'admin.unsaved.stay': 'Keep editing',
    'admin.unsaved.discard': 'Discard changes',
    'admin.import.title': 'Import JSON',
    'admin.import.subtitle': 'Same shape as SeedSeries[] in seed-data. Records are created or updated by slug.',
    'admin.import.example': 'See an example',
    'admin.import.paste': 'JSON',
    'admin.import.file': 'Choose file',
    'admin.import.preview': 'Preview',
    'admin.import.previewing': 'Previewing…',
    'admin.import.parseError': 'The JSON near line {line} is not valid.',
    'admin.import.summary': '{newSeries}, {newCards}; {updSeries} and {updCards} updated; {errors}',
    'admin.import.summary.series': '{count} new series',
    'admin.import.summary.cards': '{count} new cards',
    'admin.import.summary.cards_one': '{count} new card',
    'admin.import.summary.cards_other': '{count} new cards',
    'admin.import.summary.updatedSeries': '{count} series',
    'admin.import.summary.updatedCards': '{count} cards',
    'admin.import.summary.updatedCards_one': '{count} card',
    'admin.import.summary.updatedCards_other': '{count} cards',
    'admin.import.summary.errors': '{count} errors',
    'admin.import.summary.errors_one': '{count} error',
    'admin.import.summary.errors_other': '{count} errors',
    'admin.import.caption': 'Import preview',
    'admin.import.colKind': 'Type',
    'admin.import.colResult': 'Result',
    'admin.import.colProblem': 'Problem',
    'admin.import.kindSeries': 'Series',
    'admin.import.kindCard': 'Card',
    'admin.import.create': 'New',
    'admin.import.update': 'Update',
    'admin.import.unchanged': 'No change',
    'admin.import.error': 'Error',
    'admin.import.all': 'All',
    'admin.import.errorsOnly': 'Errors only',
    'admin.import.blocked': 'Fix {count} errors before importing',
    'admin.import.blocked_one': 'Fix {count} error before importing',
    'admin.import.blocked_other': 'Fix {count} errors before importing',
    'admin.import.previewStale': 'Text changed. Preview again.',
    'admin.import.previewTitle': 'Preview results',
    'admin.import.nothing': 'Nothing to import',
    'admin.import.execute': 'Import',
    'admin.import.confirm': 'This creates {create} and updates {update} records. Updates overwrite edits made here.',
    'admin.import.confirmAction': 'Import now',
    'admin.import.executing': 'Importing…',
    'admin.import.done': 'Import finished: {create} created, {update} updated',
    'admin.import.failed': 'Import failed. Nothing was changed.',
    'admin.import.tooManyRows': 'You can import at most {max} rows at a time (this file has {count})',
    'admin.import.tooLarge': 'You can import at most 1MB at a time',
    'error.payloadTooLarge': 'This is too large. Shorten it and try again.',
    'error.internal': 'Something went wrong. Try again later.',
    'error.actionFailed': "That didn't work. Try again.",
    'error.notFound': "That content doesn't exist or was removed.",
    'error.forbidden': "You don't have permission to do that.",
    'error.app.PARSE_ERROR': 'The request could not be read. Try again.',
    'error.app.BAD_REQUEST': 'The request is invalid. Check it and try again.',
    'error.app.VALIDATION': 'Some fields need to be changed before you can continue.',
    'error.app.INTERNAL_SERVER_ERROR': 'Something went wrong. Try again later.',
    'error.app.NOT_IMPLEMENTED': 'This action is not available yet.',
    'error.app.BAD_GATEWAY': 'The service is temporarily unavailable. Try again later.',
    'error.app.SERVICE_UNAVAILABLE': 'The service is temporarily unavailable. Try again later.',
    'error.app.GATEWAY_TIMEOUT': 'The service took too long to respond. Try again.',
    'error.app.UNAUTHORIZED': 'Your session has ended. Sign in again.',
    'error.app.FORBIDDEN': "You don't have permission to do that.",
    'error.app.NOT_FOUND': "That content doesn't exist or was removed.",
    'error.app.METHOD_NOT_SUPPORTED': 'That request method is not supported.',
    'error.app.TIMEOUT': 'The request timed out. Try again.',
    'error.app.CONFLICT': 'This already exists. Change it and try again.',
    'error.app.PRECONDITION_FAILED': 'This action is not allowed in the current state.',
    'error.app.PAYLOAD_TOO_LARGE': 'This is too large. Shorten it and try again.',
    'error.app.UNSUPPORTED_MEDIA_TYPE': 'That content format is not supported.',
    'error.app.UNPROCESSABLE_CONTENT': 'The submitted content could not be processed.',
    'error.app.TOO_MANY_REQUESTS': 'Too many actions. Try again later.',
    'error.app.CLIENT_CLOSED_REQUEST': 'The request was cancelled.',
    'error.app.WRONG_PASSWORD': 'The current password is incorrect.',
    'error.app.SAME_PASSWORD': 'The new password must be different from the current one.',
    'error.app.USER_BANNED': "Your account is banned. This action wasn't completed.",
    'error.app.CANNOT_BAN_ADMIN': "Admins can't be banned",
    'error.app.CANNOT_BAN_SELF': "You can't ban yourself",
    'error.app.ALREADY_BANNED': 'This user is already banned',
    'error.app.NOT_BANNED': 'This user is not banned',
    'error.app.UNKNOWN': 'Something went wrong. Try again later.',
    'error.app.unknown': 'Something went wrong. Try again later.',
    'error.unsupportedMedia': 'This content format is not supported.',
    'error.requestRejected': 'The request could not be verified.',
    'error.field.slug_format': 'Use lowercase letters, numbers, and hyphens only.',
    'error.field.username_too_short': 'Use at least 3 characters for the username.',
    'error.field.username_too_long': 'Use at most 24 characters for the username.',
    'error.field.username_format': 'Use letters, numbers, underscores, and hyphens only.',
    'error.field.email_format': 'Enter a valid email address.',
    'error.field.email_too_long': 'Use at most 128 characters for the email.',
    'error.field.password_too_short': 'Use at least 8 characters for the password.',
    'error.field.password_too_long': 'Use at most 128 characters for the password.',
    'error.field.identifier_too_short': 'Enter an email or username.',
    'error.field.identifier_too_long': 'Use at most 128 characters for the email or username.',
    'error.field.comment_required': 'Enter a comment.',
    'error.field.comment_too_long': 'Use at most 500 characters for the comment.',
    'error.field.title_required': 'Enter a title.',
    'error.field.title_too_long': 'Use at most 120 characters for the title.',
    'error.field.description_too_long': 'Use at most 5000 characters for the description.',
    'error.field.body_required': 'Enter a body.',
    'error.field.body_too_long': 'Use at most 10000 characters for the body.',
    'error.field.reply_required': 'Enter a reply.',
    'error.field.reply_too_long': 'Use at most 5000 characters for the reply.',
    'error.field.currency_format': 'Use a 3-letter uppercase currency code.',
    'error.field.price_range': 'Enter a price from 0 to 9,999,999,999.99.',
    'error.field.price_needs_currency': 'Choose a currency to set a price range.',
    'error.field.image_https': 'Use an image link that starts with https://.',
    'error.field.image_too_many': 'Use at most 4 images.',
    'error.field.contact_too_short': 'Use at least 2 characters for the contact.',
    'error.field.contact_too_long': 'Use at most 200 characters for the contact.',
    'error.field.note_too_long': 'Use at most 500 characters for the note.',
    'error.field.variant_note_too_long': 'Use at most 40 characters for the variant note.',
    'error.field.reason_too_short': 'Use at least 4 characters for the reason.',
    'error.field.reason_too_long': 'Use at most 500 characters for the reason.',
    'error.field.resolution_too_long': 'Use at most 500 characters for the resolution.',
    'error.field.image_url': 'Leave the image URL empty, or start it with https:// or gradient:.',
    'error.field.attributes_too_many': 'Use at most 40 attributes.',
    'error.field.invalid_date': 'Enter a valid date as YYYY-MM-DD.',
    'error.field.release_region': 'Choose China mainland, Japan, or Global.',
    'error.field.release_note_too_long': 'Use at most 500 characters for the note.',
    'error.field.source_url': 'Start the source link with https://.',
    'error.field.release_range_order': 'Choose an end date on or after the start date.',
    'error.field.release_range_too_long': 'Use at most 366 days.',
    'error.field.delete_reason_too_long': 'Use at most 500 characters for the delete reason.',
    'error.field.invalid': 'Enter a value that matches the field.',
    'error.field.invalid_type': 'Enter a value of the expected type.',
    'error.field.too_big': 'Use a shorter value.',
    'error.field.card_body_too_long': 'Use at most 20000 characters for the long description.',
    'error.field.too_small': 'Use a longer value.',
    'error.field.invalid_format': 'Use the required format.',
    'error.field.not_multiple_of': 'Enter a value that matches the required multiple.',
    'error.field.unrecognized_keys': 'Remove unrecognized fields.',
    'error.field.invalid_union': 'Enter a value that matches the field.',
    'error.field.invalid_key': 'Use a valid field name.',
    'error.field.invalid_element': 'Fix the value that does not match.',
    'error.field.invalid_value': 'Choose one of the allowed values.',
    'error.field.collection_quantity': 'Enter a whole number from 0 to 99.',
    'error.field.parallel_cross_series': 'Pick a base card from the same series.',
    'error.field.parallel_chain': 'Pick a base card, not another parallel.',
    'error.field.parallel_self': "A card can't be a parallel of itself.",
    'error.field.parallel_has_children': "This card has parallels, so it can't be a parallel.",
    'error.field.parallel_base_missing': 'Base card not found.',
    'error.field.parallel_name_required': 'Enter a parallel name.',
    'admin.import.back': 'Back to catalog',
    'admin.import.already': 'This content was already imported. Change it before importing again.',
    'miniapp.home.browse': 'Browse series',
    'miniapp.home.search': 'Search cards',
    'miniapp.home.login': 'Sign in',
    'miniapp.home.profile': 'Signed in as @{username}',
    'miniapp.home.logout': 'Sign out',
    'miniapp.home.featured': 'Featured series',
    'miniapp.home.viewAll': 'View all →',
    'miniapp.toast.loginOk': 'Signed in',
    'miniapp.toast.registerOk': 'Account created',
    'miniapp.toast.commentOk': 'Comment posted',
    'miniapp.toast.logoutOk': 'Signed out',
};
exports.dictionaries = {
    'zh-CN': zhCN,
    'en-US': enUS,
};
const pluralRulesByLocale = new Map();
function pluralRulesFor(locale) {
    const cached = pluralRulesByLocale.get(locale);
    if (cached)
        return cached;
    const rules = new Intl.PluralRules(locale);
    pluralRulesByLocale.set(locale, rules);
    return rules;
}
/** Pick `key_<category>` from Intl.PluralRules when `{count}` is a number. */
function pluralMessage(locale, key, count) {
    const dictionary = exports.dictionaries[locale];
    if (!dictionary)
        return undefined;
    const category = pluralRulesFor(locale).select(count);
    return dictionary[`${key}_${category}`] ?? dictionary[`${key}_other`];
}
/**
 * Interpolates `{name}` from `vars`. Plural keys are chosen only when `count` is a number.
 * A formatted string such as `"1,234"` stays on the base key.
 */
function t(locale, key, vars) {
    const count = vars?.count;
    const plural = typeof count === 'number' ? pluralMessage(locale, key, count) : undefined;
    const raw = plural ?? exports.dictionaries[locale]?.[key] ?? key;
    if (!vars)
        return raw;
    return raw.replace(/\{(\w+)\}/g, (_, name) => name in vars ? String(vars[name]) : `{${name}}`);
}
/** Localized copy for `error.data.appCode`. Unknown codes use the generic sentence. */
function appErrorMessage(locale, appCode) {
    if ((0, constants_1.isAppErrorCode)(appCode)) {
        const key = `error.app.${appCode}`;
        const text = t(locale, key);
        if (text !== key)
            return text;
    }
    return t(locale, 'error.app.unknown');
}
const FIELD_ERROR_CODE = /^[a-z][a-z0-9]*(_[a-z0-9]+)*$/;
function fieldErrorCodes(locale) {
    return Object.keys(exports.dictionaries[locale] ?? {})
        .filter((key) => key.startsWith('error.field.'))
        .map((key) => key.slice('error.field.'.length))
        .sort();
}
/**
 * Localized copy for a zod issue message that is a snake_case field code.
 * Anything else, including an unmapped code, uses `error.app.UNKNOWN`.
 */
function fieldErrorMessage(locale, code) {
    const unknown = t(locale, 'error.app.UNKNOWN');
    if (typeof code !== 'string' || !FIELD_ERROR_CODE.test(code))
        return unknown;
    const text = exports.dictionaries[locale]?.[`error.field.${code}`];
    return text ?? unknown;
}
//# sourceMappingURL=index.js.map